﻿/* ============================================================


   THE BALLOONWALA — Mobile App Shell


   v2 — collection-based categories, proper image sizing


   ============================================================ */


(function () {


  'use strict';





  /* ── CONFIG ── */


  const WA = '919909902920';





  /* ── CATEGORY → REAL COLLECTION HANDLES (verified from store) ── */


  const COLLECTIONS = {


    all:         'all',


    birthday:    'birthday-balloon-decoration',


    backdrop:    'birthday-decoration-theme-backdrop',


    anniversary: 'anniversary-decoration',


    romantic:    'romantic-room-decoration',


    baby:        'baby-shower-decoration',


    welcome:     'welcome-baby-balloon-decoration',


    bride:       'wedding-decoration',       // dedicated Wedding Decoration collection


    theme:       'kids-birthday',            // Kids Birthday has themed character setups


    ring:        'premium-birthday-theme-ring-decorations-for-home-and-banquet', // premium, 4 cities only

    bouquet:     'balloon-bouquets'  // Balloon Bouquets — new category, Bangalore/Mumbai/Pune only


  };





  /* ── TAG-BASED CATEGORY FILTERS ── */


  var TAG_CATS = {


    birthday:    ['Kids Birthday New', 'Kids Themed Birthday', 'Adult Birthday'],


    romantic:    ['Romantic New'],


    baby:        ['Baby Shower New'],


    welcome:     ['Welcome Baby'],


    anniversary: ['Anniversary Decoration New'],


    wedding:     ['Groom/Bride to be', 'Wedding'],


    others:      ['Others']


  };





  var BOUQUET_SUB = {
    all:      ['Common Birthday Bouquet', 'Kids Special Bouquet', 'Romantic Birthday Bouquet', 'Romantic Propose Bouquet', 'Anniversary Bouquet', 'Born Baby Celebration Bouquet', 'Congratulations Bouquet', 'For Parents Bouquet', 'Get Well Soon Bouquet'],
    common:   ['Common Birthday Bouquet'],
    kids:     ['Kids Special Bouquet'],
    propose:  ['Romantic Propose Bouquet'],
    rbd:      ['Romantic Birthday Bouquet'],
    anniv:    ['Anniversary Bouquet'],
    baby:     ['Born Baby Celebration Bouquet'],
    congrats: ['Congratulations Bouquet'],
    parents:  ['For Parents Bouquet'],
    getwell:  ['Get Well Soon Bouquet']
  };

  var BIRTHDAY_SUB = {


    all:    ['Kids Birthday New', 'Kids Themed Birthday', 'Adult Birthday'],


    adult:  ['Adult Birthday'],


    kids:   ['Kids Birthday New'],


    themed: ['Kids Themed Birthday']


  };


  /* ── STATE ── */


  const cache       = {};          // collection key → products array


  let   currentCat  = 'all';


  let   currentCity = 'Bangalore';

  let   cityGateForced = false; /* true while the mandatory first-visit city gate is blocking the app */





  /* ================================================================


     PRODUCT NORMALIZATION


     Converts raw Shopify product JSON into a flat object.


     Image URLs are sized via CDN param so we never load full-res.


  ================================================================ */


  function addW(src, w) {


    if (!src) return '';


    var sep = src.indexOf('?') > -1 ? '&' : '?';


    return src + sep + 'width=' + w + '&format=webp';


  }





  /* Pull the real "This Package Includes" bullets from body_html.


     The products store inclusions as the FIRST <ul> after the text


     "This Package includes:". We extract those <li> items verbatim. */


  function extractIncludes(html) {


    if (!html) return [];


    var firstUl = html.match(/<ul[^>]*>([\s\S]*?)<\/ul>/i);


    if (!firstUl) return [];


    var lis = firstUl[1].match(/<li[^>]*>([\s\S]*?)<\/li>/gi) || [];


    return lis.map(function (li) {


      return li.replace(/<[^>]+>/g, '').replace(/\s+/g, ' ').trim();


    }).filter(function (s) { return s && s.replace(/\./g, '').trim().length > 1; });


  }





  /* Short intro sentence = text before the first <ul>, cleaned. */


  function extractIntro(html) {


    if (!html) return '';


    var before = html.split(/<ul[^>]*>/i)[0] || '';


    return before


      .replace(/this package includes\s*:?/i, '')


      .replace(/<[^>]+>/g, '')


      .replace(/\s+/g, ' ')


      .trim()


      .slice(0, 200);


  }





  function normalize(p) {


    var variant = (p.variants && p.variants[0]) || {};


    var allVariants = (p.variants || []).map(function (v) {
      return {
        id:        String(v.id),
        title:     v.title || '',
        option1:   v.option1 || '',
        price:     Math.round(parseFloat(v.price || 0) * 100),
        available: v.available !== false
      };
    });


    var optionName = (p.options && p.options[0] && p.options[0].name) || '';


    var img     = (p.images && p.images[0] && p.images[0].src) || '';


    var tags    = (p.tags || []).map(function (t) { return String(t); });


    return {


      id:       String(p.id),


      vid:      String(variant.id || ''),


      title:    p.title || '',


      price:    Math.round(parseFloat(variant.price || 0) * 100),


      variants:    allVariants,


      hasVariants: allVariants.length > 1,


      optionName:  optionName,


      img:      addW(img, 210),


      imgFull:  addW(img, 720),


      handle:   p.handle || '',


      sku:      variant.sku || '',


      includes: extractIncludes(p.body_html),


      intro:    extractIntro(p.body_html),


      tags:     tags,


      tagsLc:   tags.map(function (t) { return t.toLowerCase(); }),


      images:   (p.images || []).map(function (i) { return i.src || ''; }),


    };


  }


  /* Splits a variant option value like "120 (For 200 sq ft area to cover)"
     into a main label ("120") and a description ("For 200 sq ft area to
     cover"). Falls back to showing the whole value as the main label if it
     doesn't match the "X (Y)" pattern. */
  function splitVariantOption(label) {
    var m = /^(.*?)\s*\(([^)]+)\)\s*$/.exec(label || '');
    if (m) return { main: m[1].trim(), sub: m[2].trim() };
    return { main: (label || '').trim(), sub: '' };
  }

  /* "No. of Balloons" -> "balloons"; used as a small unit suffix next to
     the variant's main label. Returns '' if the option name doesn't match
     the "No. of X" pattern, in which case no suffix is shown. */
  function variantUnitLabel(optionName) {
    var m = /^no\.?\s*of\s*(.+)$/i.exec((optionName || '').trim());
    return m ? m[1].trim().toLowerCase() : '';
  }





  /* Cities where "city notice required" products are available. */


  var NOTICE_CITIES = ['bangalore', 'hyderabad', 'surat', 'pune'];
  var BOUQUET_CITIES = ['bangalore', 'mumbai', 'pune']; /* Balloon Bouquets availability — Blr+Mum+Pune (Rishi 2026-11-03: Pune added back at launch) */





  /* Render-time visibility filter:


     - hides products tagged "citynoticerequired" unless the current city


       is one of the notice cities. */


  function visibleProducts(arr) {


    var city = (currentCity || '').toLowerCase();
    var cityOk = NOTICE_CITIES.indexOf(city) > -1;
    var bqOk = BOUQUET_CITIES.indexOf(city) > -1;


    return (arr || []).filter(function (p) {


      if (p.tagsLc.indexOf('bouquetcitynotice') > -1) return bqOk;
      var notice = p.tagsLc.indexOf('citynoticerequired') > -1;


      return notice ? cityOk : true;


    });


  }





  function byPriceAsc(a, b) { return a.price - b.price; }





  /* ================================================================


     DATA FETCHING — one fetch per collection, results cached


  ================================================================ */


  function fetchCollection(key) {


    if (cache[key]) return Promise.resolve(cache[key]);


    var handle = COLLECTIONS[key] || 'all';


    var acc = [], page = 1;
      function next() {
        return fetch('/collections/' + handle + '/products.json?limit=250&page=' + page)
          .then(function(r){ return r.json(); })
          .then(function(d) {
            var raw = d.products || [];
            var batch = raw.filter(function(p){ return ['Same-Day Express Fee','Outskirts Conveyance Fee'].every(function(pre){ return String(p.title||'').indexOf(pre) !== 0; }); });
            acc = acc.concat(batch);
            if (raw.length === 250) { page++; return next(); }
            var products = acc.map(normalize).sort(byPriceAsc);
            cache[key] = products;
            return products;
          })
          .catch(function(){
            var products = acc.map(normalize).sort(byPriceAsc);
            cache[key] = products;
            return products;
          });
      }
      return next();


  }





  /* Full-catalogue fetch for search — paginates /products.json so the


     250-product collection limit never truncates results. Cached for the


     session so subsequent searches are instant. */


  var _searchPool = null;


  var _sheetHashBack = false; /* guard: suppresses hashchange fired by our own history.back() */
  var _guideHashBack = false; /* same guard for the nested booking-guide sheet */
  var _worksHashBack = false; /* guard for the works gallery sheet */


  function fetchAllForSearch() {


    if (_searchPool) return Promise.resolve(_searchPool);


    var acc = [], page = 1;


    function next() {


      return fetch('/products.json?limit=250&page=' + page)


        .then(function(r) { return r.json(); })


        .then(function(d) {


          var batch = (d.products || []).map(normalize).filter(function(p){ return ['Same-Day Express Fee','Outskirts Conveyance Fee'].every(function(pre){ return String(p.title||'').indexOf(pre) !== 0; }); });


          acc = acc.concat(batch);


          if ((d.products || []).length === 250) { page++; return next(); }


          acc.sort(byPriceAsc);


          _searchPool = acc;


          return acc;


        })


        .catch(function() { return acc.length ? acc : fetchCollection('all'); });


    }


    return next();


  }





  /* ================================================================


     UTILITIES


  ================================================================ */


  function fmt(paise) {


    return '₹' + Math.round(paise / 100).toLocaleString('en-IN');


  }





  function esc(s) {


    return String(s || '').replace(/&/g,'&amp;').replace(/</g,'&lt;')


           .replace(/>/g,'&gt;').replace(/"/g,'&quot;').replace(/'/g,'&#39;');


  }





  function showToast(msg) {


    var t = document.getElementById('tbw-toast');


    if (!t) return;


    t.textContent = msg;


    t.classList.add('show');


    clearTimeout(t._timer);


    t._timer = setTimeout(function(){ t.classList.remove('show'); }, 2600);


  }





  function tbwDismissBubble(id) {


    var el = document.getElementById(id);


    if (!el) return;


    el.classList.add('tbw-bubble--hide');


    setTimeout(function(){ el.style.display = 'none'; }, 320);


  }

  function showSwipeHint() {
    /* Hint removed — close button handles discoverability */
  }








  /* ================================================================


     SKELETON LOADERS


  ================================================================ */


  function homeSkeleton() {


    return '<div class="tbw-sk" style="width:152px;height:200px;flex-shrink:0"></div>'


         + '<div class="tbw-sk" style="width:152px;height:200px;flex-shrink:0"></div>'


         + '<div class="tbw-sk" style="width:152px;height:200px;flex-shrink:0"></div>';


  }


  function exploreSkeleton() {


    var g = '<div class="tbw-sk" style="height:160px;border-radius:14px"></div>'.repeat(4);


    var l = '<div class="tbw-sk" style="height:94px;border-radius:14px;margin:0 18px 10px"></div>'.repeat(3);


    return { grid: g, list: l };


  }





  /* ================================================================


     BADGE


  ================================================================ */


  function updateBadge(total) {


    ['tbw-cart-bdg','tbw-cart-bdg2','tbw-cart-tb-badge'].forEach(function(id){


      var el = document.getElementById(id);


      if (!el) return;


      el.textContent = total;


      el.style.display = total > 0 ? 'flex' : 'none';


    });


  }





  /* ================================================================


     TAB NAVIGATION


  ================================================================ */


  function goTab(name) {


    document.querySelectorAll('.tbw-scr').forEach(function(s){ s.classList.remove('on'); });


    document.querySelectorAll('.tbw-tb').forEach(function(b){ b.classList.remove('on'); });


    var scr = document.getElementById('tbw-s-' + name);


    var tab = document.getElementById('tbw-t-' + name);


    if (scr) scr.classList.add('on');


    if (tab) tab.classList.add('on');


    if (name === 'explore') loadExplore();


    if (name === 'cart')    renderCart();


    if (name === 'profile') renderRecent();
    if (name === 'profile') renderOrders();


  }


  window.tbwGoTab = goTab;
/* ================================================================
     YOUR ORDERS v2 (localStorage-based, COD checkout tie-in)
     Spec: your-orders-block-spec.md
     Collapsible dropdown + real order capture from checkout flow.
     ================================================================ */
  var ORDERS_KEY = 'tbw_last_order';
  var ORDERS_WA  = '919909902920'; /* TBW business WhatsApp */

  /* Call this after a successful COD order to store order details. */
  function saveOrder(o) {
    try {
      var rec = {
        orderId:    o.orderId    || '',
        orderNumber:o.orderNumber|| '',
        date:       o.date       || '',
        city:       o.city       || (typeof currentCity !== 'undefined' ? currentCity : ''),
        items:      Array.isArray(o.items) ? o.items : [],
        total:      o.total      || '',
        phone:      o.phone      || '',
        status:     o.status     || 'Confirmed',
        ts:         Date.now()
      };
      localStorage.setItem(ORDERS_KEY, JSON.stringify(rec));
    } catch (e) {}
  }
  window.tbwSaveOrder = saveOrder;

  /* Read stored order (or null). */
  function readOrder() {
    try {
      var raw = localStorage.getItem(ORDERS_KEY);
      if (!raw) return null;
      var o = JSON.parse(raw);
      if (o && (o.kind === 'booking' || o.orderNumber)) {
        /* bookings drop out of the drawer after 14 days */
        if (o.kind === 'booking' && o.ts && Date.now() - o.ts > 2592000000) {
          try { localStorage.removeItem(ORDERS_KEY); } catch (e2) {}
          return null;
        }
        return o;
      }
    } catch (e) {}
    return null;
  }

  /* Escape helper for inline HTML (reuses esc if available). */
  function escO(s) {
    if (typeof esc === 'function') return esc(s);
    return String(s == null ? '' : s)
      .replace(/&/g, '&')
      .replace(/</g, '<')
      .replace(/>/g, '>')
      .replace(/"/g, '&#34;')
      .replace(/'/g, '&#39;');
  }

  /* Build the WhatsApp "Continue on WhatsApp" deep link for an order. */
  function ordersWaLink(o) {
    var lines = (o.items || []).map(function (it) {
      return '- ' + it.name + (it.qty ? ' x' + it.qty : '');
    });
    if (o.kind === 'booking') {
      var bmsg =
        "Hi! I placed a booking on TheBalloonwala.\n\n" +
        "Booked on: " + (o.date || '') + "\n" +
        (o.eventDate ? "Event date: " + o.eventDate + "\n" : "") +
        (o.city ? "City: " + o.city + "\n" : "") +
        (lines.length ? "Items:\n" + lines.join("\n") + "\n" : "") +
        (o.total ? "Items total: \u20B9" + o.total + " (delivery extra, as applicable)\n" : "") +
        "\nCould you share the next steps / confirmation? Thank you!";
      return 'https://wa.me/' + ORDERS_WA + '?text=' + encodeURIComponent(bmsg);
    }
    var msg =
      "Hi! I'm following up on my order " + o.orderNumber + ".\n\n" +
      "Order: " + o.orderNumber + "\n" +
      "Date: "  + (o.date || '') + "\n" +
      "City: "  + (o.city || '') + "\n" +
      (lines.length ? "Items:\n" + lines.join("\n") + "\n" : "") +
      "Total: " + (o.total ? o.total : '') + "\n\n" +
      "Could you share the next steps? Thank you!";
    return 'https://wa.me/' + ORDERS_WA + '?text=' + encodeURIComponent(msg);
  }

  /* Format a price in paise to rupees string. */
  function ordersFmtPrice(paise) {
    if (!paise && paise !== 0) return '';
    var rs = Math.round(paise / 100);
    return String(rs);
  }

  /* Booking-return gate (2026-09-22, replaces checkCompletedOrder).
     Old behaviour invented an order number ('#TBW' + timestamp digits) and
     promoted ANY pending snapshot whenever the cart read empty - including
     fresh loads before hydrateCart() filled the cart, so mere checkout
     visitors got a fake 'Confirmed' order. New rules:
     1. purge fabricated '#TBW...' records left on returning phones
     2. drop legacy/stale pendings (written without v:2 or >24h old - they
        can never promote)
     3. promote ONLY when the customer went to checkout (30-day tbw_cktrip
        cookie - survives closed tabs and new sessions) and their cart was
        consumed by the order. Abandoners return with items still in the
        cart and get nothing.
     Runs after hydrateCart() resolves, never before. */
  function clearCkTrip() {
    try {
      document.cookie = 'tbw_cktrip=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT';
    } catch (e) {}
  }
  function checkBookingReturn() {
    try {
      var raw = localStorage.getItem(ORDERS_KEY);
      if (raw) {
        var prev = null;
        try { prev = JSON.parse(raw); } catch (e) {}
        if (!prev || (prev.orderNumber && /^#TBW\d+$/.test(prev.orderNumber))) {
          localStorage.removeItem(ORDERS_KEY);
        }
      }
      var pRaw = localStorage.getItem('tbw_pending_order'), po = null;
      if (pRaw) {
        try { po = JSON.parse(pRaw); } catch (e) {}
        if (!po || po.v !== 2 || (Date.now() - (po.ts || 0)) > 2592000000) {
          localStorage.removeItem('tbw_pending_order');
          clearCkTrip();
          po = null;
        }
      }
      if (!po) return;
      var returned = false;
      try { returned = /(?:^|;\s*)tbw_cktrip=1(?:;|$)/.test(document.cookie); } catch (e) {}
      if (returned) {
        if (cart && cart.length === 0) {
          localStorage.setItem(ORDERS_KEY, JSON.stringify({
            kind:      'booking',
            date:      po.date || new Date().toISOString().slice(0, 10),
            eventDate: po.eventDate || '',
            city:      po.city || '',
            items:     po.items || [],
            total:     po.total || '',
            status:    'Awaiting confirmation',
            ts:        po.ts
          }));
          localStorage.removeItem('tbw_pending_order');
        }
        /* order consumed the cart (promoted) or the customer bailed with
           items still in hand - either way this checkout trip is over */
        clearCkTrip();
      }
    } catch (e) {}
  }

  /* Save pending booking snapshot right before redirecting to checkout.
     Called from tbwGoCheckout(). Also drops a 30-day tbw_cktrip cookie so a
     later visit - even a new tab or session - can still detect the checkout
     trip and show the booking once the cart is empty. */
  function savePendingOrder() {
    try {
      if (!cart || !cart.length) return;
      var items = cart.map(function (c) {
        return { name: c.title || '', qty: c.qty || 1, price: c.price || 0 };
      });
      var totalPaise = cart.reduce(function (s, c) {
        return s + ((c.price || 0) * (c.qty || 1));
      }, 0);
      var ev = '';
      for (var i = 0; i < cart.length; i++) {
        if (cart[i] && cart[i].date) { ev = cart[i].date; break; }
      }
      var rec = {
        v:         2,
        items:     items,
        total:     ordersFmtPrice(totalPaise),
        date:      new Date().toISOString().slice(0, 10),
        eventDate: ev,
        city:      (typeof currentCity !== 'undefined' ? currentCity : ''),
        ts:        Date.now()
      };
      localStorage.setItem('tbw_pending_order', JSON.stringify(rec));
      /* 30-day cookie marker: survives closed tabs and new sessions, so a
         customer who pays and returns days later still gets the booking
         shown once the cart is empty (Rishi, 2026-09-22) */
      try {
        document.cookie = 'tbw_cktrip=1; path=/; expires=' +
          new Date(Date.now() + 2592000000).toUTCString() + '; SameSite=Lax; Secure';
      } catch (e2) {}
    } catch (e) {}
  }

  /* Render the "Your Orders" block into #tbw-orders-box.
     Collapsible dropdown style -- header always visible, body toggles. */
  function renderOrders() {
    var box = document.getElementById('tbw-orders-box');
    if (!box) return;
    var o = readOrder();

    /* Header (always visible) -- clickable to toggle */
    var headerHtml =
      '<div class="tbw-orders-hdr" id="tbw-orders-hdr" onclick="tbwToggleOrders()">' +
        '<span class="tbw-orders-hdr-ic">' + (o ? '\u{1F4E6}' : '\u{1F388}') + '</span>' +
        '<span class="tbw-orders-hdr-t">Your Orders</span>' +
        (o ? '<span class="tbw-orders-hdr-badge">' + escO(o.kind === 'booking' ? (o.eventDate || o.city || 'Booking') : o.orderNumber) + '</span>' : '') +
        '<span class="tbw-orders-hdr-arrow" id="tbw-orders-arrow">\u234C</span>' +
      '</div>';

    /* Body (collapsible) */
    var bodyHtml = '<div class="tbw-orders-body" id="tbw-orders-body" style="display:none">';

    if (!o) {
      /* STATE 1 - Empty state */
      bodyHtml +=
        '<div class="tbw-orders-empty">' +
          '<div class="tbw-orders-empty-ic">\u{1F388}</div>' +
          '<div class="tbw-orders-empty-t">Oops! Nothing here yet \u{1F388}</div>' +
          '<div class="tbw-orders-empty-s">You\'re missing out on the best balloon decoration experience. Place your order and let\'s make it memorable!</div>' +
          '<button class="tbw-orders-empty-btn" onclick="tbwOrderBookNow()">Book Now</button>' +
        '</div>';
    } else {
      /* STATE 2 - Filled state */
      var itemsHtml = (o.items || []).map(function (it) {
        return '<div class="tbw-orders-item">' +
          '<span class="tbw-orders-item-n">' + escO(it.name || '') + '</span>' +
          '<span class="tbw-orders-item-q">' + (it.qty ? 'x' + escO(it.qty) : '') + '</span>' +
        '</div>';
      }).join('');

      var waHref = ordersWaLink(o);
      var statusClass = (o.status || '').toLowerCase() === 'confirmed' ? 'ok' : 'pending';

      bodyHtml +=
        '<div class="tbw-orders-card">' +
          '<div class="tbw-orders-card-top">' +
            '<div class="tbw-orders-card-no">' + escO(o.kind === 'booking' ? ('Booking \u00B7 ' + (o.eventDate || o.date || '')) : o.orderNumber) + '</div>' +
            '<span class="tbw-orders-badge tbw-orders-badge-' + statusClass + '">' + escO(o.status || 'Confirmed') + '</span>' +
          '</div>' +
          '<div class="tbw-orders-card-meta">' +
            '<span>\u{1F4C5} ' + escO((o.kind === 'booking' && o.eventDate) ? o.eventDate : (o.date || '')) + '</span>' +
            (o.city ? '<span>\u{1F4CD} ' + escO(o.city) + '</span>' : '') +
          '</div>' +
          (itemsHtml ? '<div class="tbw-orders-items">' + itemsHtml + '</div>' : '') +
          (o.total ? '<div class="tbw-orders-total">' + (o.kind === 'booking' ? ('Items total: \u20B9' + escO(o.total) + ' + delivery') : ('Total: \u20B9' + escO(o.total))) + '</div>' : '') +
          '<a class="tbw-orders-wa" href="' + waHref + '" target="_blank" rel="noopener">' +
            '<span class="tbw-orders-wa-ic">\u{1F4AC}</span> Continue on WhatsApp' +
          '</a>' +
        '</div>';
    }

    bodyHtml += '</div>';

    box.innerHTML = headerHtml + bodyHtml;
  }

  /* Toggle dropdown open/closed */
  window.tbwToggleOrders = function () {
    var body = document.getElementById('tbw-orders-body');
    var arrow = document.getElementById('tbw-orders-arrow');
    if (!body) return;
    if (body.style.display === 'none') {
      body.style.display = 'block';
      if (arrow) arrow.style.transform = 'rotate(180deg)';
    } else {
      body.style.display = 'none';
      if (arrow) arrow.style.transform = 'rotate(0deg)';
    }
  };

  /* Empty-state CTA: open the first product sheet or fall back to Explore tab. */
  window.tbwOrderBookNow = function () {
    try {
      if (typeof openSheet === 'function') {
        var sections = (typeof HOME_SECTIONS !== 'undefined') ? HOME_SECTIONS : [];
        for (var i = 0; i < sections.length; i++) {
          var key = sections[i].key;
          if (window._cache && window._cache[key] && window._cache[key].length) {
            openSheet(window._cache[key][0].id);
            return;
          }
        }
      }
    } catch (e) {}
    try { if (window.tbwGoTab) window.tbwGoTab('explore'); } catch (e) {}
  };







  /* ================================================================


     RECENTLY VIEWED (localStorage)


  ================================================================ */


  function pushRecent(p) {


    try {


      var arr = JSON.parse(localStorage.getItem('tbw_recent') || '[]');


      arr = arr.filter(function (x) { return x.id !== p.id; });


      arr.unshift({ id: p.id, title: p.title, price: p.price, img: p.img, handle: p.handle });


      localStorage.setItem('tbw_recent', JSON.stringify(arr.slice(0, 12)));


    } catch (e) {}


  }





  function renderRecent() {


    var w = document.getElementById('tbw-recent');


    if (!w) return;


    var arr = [];


    try { arr = JSON.parse(localStorage.getItem('tbw_recent') || '[]'); } catch (e) {}


    if (!arr.length) {


      w.innerHTML = '<div style="padding:6px 18px 4px;font-size:12px;color:var(--muted);font-weight:300">No recently viewed setups yet — tap any decoration to see it here.</div>';


      return;


    }


    w.innerHTML = arr.map(function (p) {


      return '<a class="tbw-pcv" href="/products/' + esc(p.handle) + '"'


        + ' onclick="event.preventDefault();tbwOpenSheet(\'' + esc(p.id) + '\')">'


        + '<div class="tbw-pcv-iw">'


        + (p.img ? '<img src="' + esc(p.img) + '" loading="lazy" alt="' + esc(p.title) + '" onerror="this.style.display=\'none\'"/>' : '')


        + '</div>'


        + '<div class="tbw-pcv-body">'


        + '<div class="tbw-pcv-nm">' + esc(p.title) + '</div>'


        + '<div class="tbw-pcv-pr">' + fmt(p.price) + '</div>'


        + '</div></a>';


    }).join('');


  }





  /* Blink the cart tab icon (after add to cart). */


  function blinkCart() {


    var t = document.getElementById('tbw-t-cart');


    if (!t) return;


    t.classList.add('tbw-cart-blink');


    setTimeout(function () { t.classList.remove('tbw-cart-blink'); }, 1100);


  }





  /* ================================================================


     SHARED PRODUCT CARD (2-col grid style — matches prototype .pcv)


  ================================================================ */


  function gridCard(p) {


    var tag = '';


    if (p.tagsLc.indexOf('theme-decoration') > -1) tag = '<div class="tbw-pcv-tag tbw-t-p">Themed</div>';


    else if (p.price < 200000)                     tag = '<div class="tbw-pcv-tag tbw-t-b">Budget</div>';


    /* Second image (if any) — revealed on hover (mouse) or press (touch). */


    var img2 = (p.images && p.images.length > 1)


      ? '<img class="tbw-pcv-img2" src="" data-src="' + esc(addW(p.images[1], 210)) + '" loading="lazy" decoding="async" alt="" aria-hidden="true" onerror="this.remove()"/>'


      : '';


    var touchSwap = img2


      ? ' ontouchstart="(function(el){var i=el.querySelector(\'.tbw-pcv-img2\');if(i&&i.dataset.src){i.src=i.dataset.src;i.removeAttribute(\'data-src\');}el.classList.add(\'tbw-show2\');})(this)" ontouchend="this.classList.remove(\'tbw-show2\')" ontouchcancel="this.classList.remove(\'tbw-show2\')"'


      : '';


    return '<a class="tbw-pcv" style="width:100%" href="/products/' + esc(p.handle) + '"'


      + ' onclick="event.preventDefault();tbwOpenSheet(\'' + esc(p.id) + '\')"' + touchSwap + '>'


      + '<div class="tbw-pcv-iw">'


      + (p.img ? '<img class="tbw-pcv-img1" src="' + esc(p.img) + '" loading="lazy" decoding="async" alt="' + esc(p.title) + '" onerror="this.style.display=\'none\'"/>' : '')


      + img2


      + tag


      + '</div>'


      + '<div class="tbw-pcv-body">'


      + '<div class="tbw-pcv-nm">' + esc(p.title) + '</div>'


      + '<div class="tbw-pcv-pr-row">'


      + '<div class="tbw-pcv-pr">' + (p.hasVariants ? 'From ' + fmt(Math.min.apply(null, p.variants.map(function(v){ return v.price; }))) : fmt(p.price)) + '</div>'


      + '<button class="tbw-pcv-share-sm" onclick="event.stopPropagation();tbwShareProduct(\'' + esc(p.handle) + '\',\'' + esc(p.title) + '\')">🔗</button>'


      + '</div>'


      + '<button class="tbw-pcv-wa" onclick="event.stopPropagation();tbwQuickWA(\'' + esc(p.title) + '\',\'' + esc(p.handle) + '\')">💬 Enquire</button>'


      + '</div></a>';


  }





  /* ================================================================


     HOME SCREEN — alternating category sections + review carousels


  ================================================================ */


  /* ── REVIEW ENGINE ──


     A pool of realistic, MIXED-sentiment reviews (mostly happy, a few with


     a small hiccup that was resolved). Each review carries a rating so cards


     show the real star count. Names + localities are assigned per-city so


     that, e.g., when "Bangalore" is selected the reviews read as Bangalore. */


  /* Each review may carry an optional `cat` (category key). Reviews WITHOUT a


     cat are occasion-neutral and may appear anywhere. Reviews WITH a cat only


     appear under that category — so e.g. an anniversary review never shows on a


     birthday product, and vice-versa. */


  var REVIEW_POOL = [


    /* ── occasion-neutral (service, COD, quality, punctuality, value) ── */


    { t:'Decoration was stunning. Paid only after we saw it and loved it. Will book again!', r:5 , img:'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review1.jpg'},


    { t:'COD made it totally risk-free — paid after the setup, exactly as promised.', r:5 },


    { t:'Booked late at night for next morning — confirmed on WhatsApp within minutes.', r:5 },


    { t:'Good quality balloons, no marks or tape left on the walls. Very neat work.', r:5 , img:'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review2.jpg'},


    { t:'Team was polite, quick and cleaned up everything before leaving.', r:5 },


    { t:'Exactly like the picture. No advance, no stress. Highly recommend.', r:5 },


    { t:'Team reached a little late, but the setup was so good we forgot about it.', r:4 , img:'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review3.jpg'},


    { t:'A few foil letters were damaged on arrival — replaced within the hour. Efficient.', r:4 },


    { t:'Setup was slightly different from the photo, but they adjusted it on the spot.', r:4 },


    { t:'Decent work for the price. Finishing could be a touch neater, but overall happy.', r:3 , img:'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review4.jpg'},


    { t:'They kept me updated on WhatsApp the whole time. Smooth experience.', r:5 },


    { t:'Simple, clean and on budget. Did exactly what we asked.', r:5 },


    { t:'Reasonable price and the quality matched the bigger brands. Worth it.', r:5 , img:'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review5.jpg'},


    { t:'Booking took five minutes. Decorators arrived on time and were professional.', r:5 },


    { t:'Loved that I paid only after the work was done. Builds real trust.', r:5 },


    { t:'Took a bit of coordination over the address, but once they arrived it was perfect.', r:4 , img:'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review6.jpg'},


    { t:'The team was patient with my last-minute changes. Great service.', r:5 },


    { t:'Beautiful setup and they finished well before the guests arrived.', r:5 },


    { t:'Helpful staff on WhatsApp — answered all my questions before booking.', r:5 , img:'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review7.jpg'},


    { t:'Slightly pricey, but the quality and punctuality justified it.', r:4 },


    { t:'Everything was as promised. No hidden charges at all.', r:5 },


    { t:'Quick response, fair price, and a gorgeous result. Five stars.', r:5 , img:'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review8.jpg'},


    { t:'They redid one section when I wasn’t happy — no arguments at all. Superb.', r:5 },


    { t:'On-time arrival and very tidy work. Couldn’t ask for more.', r:5 },


    { t:'The colours were richer than I expected. Guests kept asking who did it.', r:5 , img:'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review9.jpg'},


    { t:'Honestly the easiest booking I’ve done. COD sealed the deal.', r:5 },


    { t:'Minor delay in starting, but they made up for it with extra balloons.', r:4 },


    { t:'Professional from enquiry to finish. Will use them every time.', r:5 , img:'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review10.jpg'},


    { t:'Great value — I compared three vendors and this was the best.', r:5 },


    { t:'Set up exactly on time for a surprise. Timing was perfect.', r:5 },


    { t:'Polite team, neat finishing, and no mess left behind.', r:5 , img:'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review11.jpg'},


    { t:'Communication could be a touch faster, but the work was lovely.', r:4 },


    { t:'They confirmed availability instantly and delivered exactly that.', r:5 },


    { t:'Paid cash after the setup. Felt completely safe and genuine.', r:5 , img:'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review12.jpg'},


    { t:'Stunning result for a modest budget. Thank you, team!', r:5 },


    { t:'Reliable and trustworthy — rare these days. Strongly recommended.', r:5 },


    { t:'Setup was done quietly while we were at breakfast. Came back to a surprise.', r:5 , img:'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review13.jpg'},


    { t:'Sent a reference photo on WhatsApp and they matched it almost exactly.', r:5 },


    { t:'No damage to the walls at all. They use command strips, very thoughtful.', r:5 },


    { t:'Was worried after reading some online reviews about other vendors. This was flawless.', r:5 , img:'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review14.jpg'},


    { t:'The team explained every element before starting. Felt very professional.', r:5 },


    { t:'COD was the main reason I chose them. No regrets — setup was beautiful.', r:5 },


    { t:'Responded to my WhatsApp at 11 PM and confirmed the slot. Impressive.', r:5 , img:'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review15.jpg'},


    { t:'Balloons were still inflated the next morning. Good quality material.', r:5 },


    { t:'Team finished 30 minutes early and waited outside until we were ready.', r:5 },


    { t:'The colour combination they suggested was better than what I had in mind.', r:5 , img:'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review16.jpg'},


    { t:'First time using a decoration service — they made it very easy.', r:5 },


    { t:'Compared to what I saw on Instagram, the real setup was even better.', r:5 },


    { t:'They covered the whole room with minimal materials. Efficient and beautiful.', r:5 , img:'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review17.jpg'},


    { t:'Three of my friends have now booked after seeing what they did for us.', r:5 },


    { t:'Price was clearly listed — no surprise charges when they arrived.', r:5 },


    { t:'The foil balloons held their shape all through the evening. Quality stuff.', r:5 , img:'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review18.jpg'},


    { t:'We have used them twice now. Consistent quality both times.', r:5 },


    { t:'Did a great job working around our furniture without moving anything.', r:5 },


    { t:'The LED curtain lights added so much warmth. Really elevated the whole look.', r:5 , img:'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review19.jpg'},


    { t:'One balloon popped during setup and they replaced it without us asking.', r:5 },


    { t:'Very prompt — was there at the exact time slot they gave.', r:5 },


    { t:'Appreciated that they double-checked the address details before coming.', r:5 , img:'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review20.jpg'},


    { t:'Simple package but they added a few extra touches that made it special.', r:5 },


    { t:'My mother was absolutely delighted. Setup was elegant and tasteful.', r:5 },


    { t:'Handled a tricky ceiling setup with no ladder marks or damage. Skilled team.', r:5 , img:'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review21.jpg'},


    { t:'First impression when we opened the door was jaw-dropping. Loved it.', r:5 },


    { t:'The advance photos they sent for approval were spot on.', r:5 },


    { t:'Politely declined my tip and said the quality was guarantee enough. Wow.', r:5 , img:'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review22.jpg'},


    { t:'Kids ran into the room and screamed with happiness. Mission accomplished.', r:5 },


    { t:'Slight miscommunication on timing but they adjusted and still finished on time.', r:4 },


    { t:'The budget package looked far more premium than the price suggested.', r:5 , img:'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review23.jpg'},


    { t:'I had changed my mind twice on the theme and they handled it patiently.', r:4 },


    { t:'WhatsApp updates throughout the setup gave us peace of mind.', r:5 },


    { t:'Neat, fast and zero fuss. Exactly what we needed.', r:5 , img:'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review24.jpg'},


    /* ── birthday ── */


    { t:'Booked for my son’s 1st birthday. On time, neat, and the kids loved it.', r:5, cat:'birthday' },


    { t:'Perfect birthday surprise for my husband — he was speechless.', r:5, cat:'birthday' },


    { t:'The birthday backdrop looked premium and the photos came out amazing.', r:5, cat:'birthday' , img:'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review25.jpg'},


    { t:'Last-minute birthday setup and they still nailed every detail.', r:5, cat:'birthday' },


    { t:'Birthday decoration was vibrant and exactly the theme we picked.', r:4, cat:'birthday' },


    { t:'Booked a midnight surprise for my best friend. Team was silent and swift.', r:5, cat:'birthday' , img:'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review26.jpg'},


    { t:'The balloon arch for my daughter\'s birthday was massive and gorgeous.', r:5, cat:'birthday' },


    { t:'Gold and white birthday setup looked like a professional photoshoot.', r:5, cat:'birthday' },


    { t:'My son insisted on a specific theme and they delivered it perfectly.', r:5, cat:'birthday' , img:'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review27.jpg'},


    { t:'Sweet 16 decoration was elegant — not too childish, not too adult. Just right.', r:5, cat:'birthday' },


    { t:'The "Happy Birthday" foil letters were huge and crisp. Loved it.', r:5, cat:'birthday' },


    { t:'Milestone 50th birthday setup — guests thought we hired an event company.', r:5, cat:'birthday' , img:'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review28.jpg'},


    { t:'Surprise birthday for my dad. He was completely caught off guard. Perfect.', r:5, cat:'birthday' },


    /* ── anniversary ── */


    { t:'Surprised my wife for our anniversary. COD made it risk-free — exceeded expectations!', r:5, cat:'anniversary' },


    { t:'Anniversary surprise came out beautifully. Worth every rupee.', r:5, cat:'anniversary' , img:'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review29.jpg'},


    { t:'Anniversary setup with the lights — my partner teared up. Gorgeous.', r:5, cat:'anniversary' },


    { t:'Our anniversary room looked straight out of a movie. Loved it.', r:5, cat:'anniversary' },


    { t:'Silver anniversary celebration — the decoration matched our theme exactly.', r:5, cat:'anniversary' , img:'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review30.jpg'},


    { t:'Heart-shaped balloon setup for our first anniversary. She cried happy tears.', r:5, cat:'anniversary' },


    { t:'They recreated elements from our wedding decor for our anniversary. Thoughtful.', r:5, cat:'anniversary' },


    { t:'10 years together and this was the best anniversary surprise yet.', r:5, cat:'anniversary' , img:'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review31.jpg'},


    /* ── romantic ── */


    { t:'Romantic room setup was magical. Polite, quick and clean.', r:5, cat:'romantic' },


    { t:'The romantic decor with petals and balloons was breathtaking.', r:5, cat:'romantic' },


    { t:'Set the perfect mood for our special night. Tasteful and elegant.', r:5, cat:'romantic' , img:'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review32.jpg'},


    { t:'Romantic surprise turned out even better than the photos.', r:4, cat:'romantic' },


    { t:'Rose petals on the bed, candles on the ledge, balloons on the ceiling. Perfect.', r:5, cat:'romantic' },


    { t:'The romantic setup was tasteful and not over the top. Exactly what I wanted.', r:5, cat:'romantic' , img:'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review33.jpg'},


    { t:'My partner thought I had arranged it myself. That is how natural it looked.', r:5, cat:'romantic' },


    /* ── baby shower ── */


    { t:'Last-minute baby shower and they nailed it. Exact theme, within budget.', r:5, cat:'baby' },


    { t:'Our baby shower decor was adorable — exactly the soft pastel theme.', r:5, cat:'baby' , img:'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review34.jpg'},


    { t:'Baby shower setup was elegant and the guests were really impressed.', r:5, cat:'baby' },


    { t:'Pastel theme baby shower looked dreamy. So many compliments from guests.', r:5, cat:'baby' },


    { t:'Balloon garland for the baby shower was the centrepiece of all photos.', r:5, cat:'baby' , img:'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review35.jpg'},


    { t:'Gender reveal colours integrated into the baby shower setup perfectly.', r:5, cat:'baby' },


    /* ── welcome baby ── */


    { t:'Welcome baby decoration was so cute — perfect to bring our newborn home to.', r:5, cat:'welcome' },


    { t:'The welcome baby setup made our homecoming truly special.', r:5, cat:'welcome' , img:'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review36.jpg'},


    { t:'Sweet welcome baby decor, gentle colours, beautifully done.', r:4, cat:'welcome' },


    { t:'Bringing our baby home to that decorated room was a memory we will keep forever.', r:5, cat:'welcome' },


    { t:'Soft yellow and white welcome baby setup — gentle and perfect for a newborn.', r:5, cat:'welcome' , img:'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review37.jpg'},


    /* ── wedding · bride & groom ── */


    { t:'Our wedding room decoration was elegant and grand. Highly recommend.', r:5, cat:'bride' },


    { t:'Bride-to-be surprise setup was stunning. Everyone loved it.', r:5, cat:'bride' },


    { t:'Wedding decor was rich and classy — exactly our theme.', r:5, cat:'bride' , img:'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review38.jpg'},


    { t:'Bridal room setup the night before the wedding was magical. Bride was in tears.', r:5, cat:'bride' },


    { t:'Mehendi night decoration was colourful and festive. Exactly what we pictured.', r:5, cat:'bride' },


    { t:'Grand wedding room setup with drapes and lights. Our guests were stunned.', r:5, cat:'bride' , img:'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review39.jpg'},


    /* ── kids & themed ── */


    { t:'The Spiderman theme for my son was spot on — he was thrilled!', r:5, cat:'theme' },


    { t:'Got a Barbie-themed setup and it was picture-perfect.', r:5, cat:'theme' },


    { t:'Themed character decoration was detailed and colourful. Kids loved it.', r:4, cat:'theme' , img:'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review40.jpg'},


    { t:'Minecraft theme for my 8-year-old — the blocks and creepers were spot on.', r:5, cat:'theme' },


    { t:'Princess castle theme looked stunning. My daughter felt like royalty.', r:5, cat:'theme' },


    { t:'Superhero theme had every character present. My son knew them all by name.', r:5, cat:'theme' , img:'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review41.jpg'},


    { t:'Frozen theme was so accurate my daughter asked if Elsa had visited.', r:5, cat:'theme' }


  ];





  var REVIEW_NAMES = [


    'Priya S.','Rahul M.','Ananya P.','Vikram R.','Sneha K.','Arjun D.','Meera J.','Karthik S.',


    'Divya N.','Rohit B.','Pooja V.','Aditya G.','Neha T.','Sanjay K.','Shruti R.','Manish A.',


    'Kavya H.','Harish P.','Ritika S.','Nikhil J.',


    'Tanvi B.','Rohan K.','Swati M.','Deepak R.','Ankita S.','Vishal P.','Nandini G.','Suresh T.',


    'Pallavi N.','Amit V.','Riya C.','Gaurav H.','Preeti L.','Shankar D.','Ishita M.','Varun A.',


    'Bhavna S.','Lokesh K.','Smita R.','Arun J.'


  ];





  var REVIEW_COLORS = ['#e84830','#c8880a','#1a7a45','#7b2ff7','#0a7ea4'];





  /* Localities per city — falls back to the city name itself for any city


     not listed here (e.g. Ahmedabad / Kolkata / Chennai). */


  var CITY_AREAS = {


    bangalore:  ['Indiranagar','Koramangala','Whitefield','HSR Layout','JP Nagar','Marathahalli'],


    mumbai:     ['Andheri','Bandra','Powai','Borivali','Thane','Chembur'],


    delhi:      ['Dwarka','Rohini','Saket','Lajpat Nagar','Janakpuri'],


    hyderabad:  ['Gachibowli','Banjara Hills','Kondapur','Madhapur','Kukatpally'],


    pune:       ['Kothrud','Hinjewadi','Viman Nagar','Baner','Wakad'],


    surat:      ['Adajan','Vesu','Katargam','Piplod'],


    ahmedabad:  ['Satellite','Bopal','Maninagar','Vastrapur'],


    kolkata:    ['Salt Lake','Park Street','Behala','New Town'],


    chennai:    ['Adyar','Velachery','T. Nagar','Anna Nagar'],


    gurgaon:    ['DLF Phase 3','Sohna Road','Sector 56','Golf Course Road'],


    jaipur:     ['Malviya Nagar','Vaishali Nagar','Mansarovar','C-Scheme'],


    chandigarh: ['Sector 17','Sector 35','Panchkula','Mohali'],


    indore:     ['Vijay Nagar','Palasia','Rau','Bhawarkua'],


    lucknow:    ['Gomti Nagar','Hazratganj','Aliganj','Indira Nagar'],


    raipur:     ['Shankar Nagar','Pandri','Telibandha','Civil Lines']


  };





  /* Deterministic hash so a product always shows the same reviews. */


  function hashStr(s) {


    var h = 0; s = String(s || '');


    for (var i = 0; i < s.length; i++) { h = ((h << 5) - h + s.charCodeAt(i)) | 0; }


    return Math.abs(h);


  }





  function starStr(r) {


    r = Math.max(1, Math.min(5, r || 5));


    return '★★★★★'.slice(0, r) + '☆☆☆☆☆'.slice(0, 5 - r);


  }





  /* Pool restricted to a category: neutral reviews (no cat) + reviews matching


     `cat`. Keeps anniversary reviews off birthday products and vice-versa.


     Falls back to the full pool for unknown / 'all' categories. */


  function poolForCat(cat) {


    if (!cat || cat === 'all') return REVIEW_POOL;


    var sub = REVIEW_POOL.filter(function (rv) { return !rv.cat || rv.cat === cat; });


    return sub.length >= 4 ? sub : REVIEW_POOL;


  }





  /* Build `count` reviews for a given seed + city (+ optional category).


     Stable for the same inputs. */


  function pickReviewsFor(seed, count, city, cat) {


    var cityName = (city || currentCity || '');


    var key      = cityName.toLowerCase();


    var known    = CITY_AREAS[key];                 /* known localities, or undefined */


    var areas    = known || [cityName];             /* fallback: just the city name */


    var pool     = poolForCat(cat);


    var out = [];


    for (var k = 0; k < count; k++) {


      var idx  = (seed * 7 + k * 3) % pool.length;


      var rev  = pool[idx];


      var area = areas[(seed + k) % areas.length];


      /* "Indiranagar, Bangalore" for known cities; just "Ahmedabad" otherwise. */


      var label = known ? (area + ', ' + cityName) : cityName;


      out.push({


        t: rev.t,


        r: rev.r,


        img: rev.img ? addW(rev.img, 600) : null,


        n: REVIEW_NAMES[(seed * 5 + k * 2) % REVIEW_NAMES.length],


        l: label,


        c: REVIEW_COLORS[(seed + k) % REVIEW_COLORS.length]


      });


    }


    return out;


  }





  /* Back-compat shim for the home carousels (3 city-aware reviews). */


  function pickReviews(seed) { return pickReviewsFor(seed, 4, currentCity); }





  /* "Google Verified" + "Verified User" badge row, shown under every review. */


  function reviewBadges() {


    return '<div class="tbw-rv-badges">'


      + '<span class="tbw-rv-bdg tbw-rv-bdg--g">'


      + '<svg viewBox="0 0 24 24" width="11" height="11" aria-hidden="true">'


      + '<path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.2 3.32v2.77h3.57c2.08-1.92 3.27-4.74 3.27-8.1z"/>'


      + '<path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.65l-3.57-2.77c-.99.66-2.26 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84A11 11 0 0 0 12 23z"/>'


      + '<path fill="#FBBC05" d="M5.84 14.11a6.6 6.6 0 0 1 0-4.22V7.05H2.18a11 11 0 0 0 0 9.9l3.66-2.84z"/>'


      + '<path fill="#EA4335" d="M12 4.75c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 1.46 14.97.5 12 .5A11 11 0 0 0 2.18 7.05l3.66 2.84C6.71 6.68 9.14 4.75 12 4.75z"/>'


      + '</svg>Google Verified</span>'


      + '<span class="tbw-rv-bdg tbw-rv-bdg--v">✓ Verified User</span>'


      + '</div>';


  }





  function reviewCarousel(list) {


    return '<div class="tbw-hs" style="margin:4px 0 20px">' + list.map(function (r) {


      return '<div class="tbw-rv"><div class="tbw-rv-stars">' + starStr(r.r) + '</div>'


        + (r.img ? '<img class="tbw-rv-photo" src="' + esc(r.img) + '" loading="lazy" alt=""/>' : '')


        + '<p class="tbw-rv-txt">"' + esc(r.t) + '"</p>'


        + '<div class="tbw-rv-auth"><div class="tbw-rv-av" style="background:' + r.c + '">' + esc(r.n.charAt(0)) + '</div>'


        + '<div><div class="tbw-rv-nm">' + esc(r.n) + '</div><div class="tbw-rv-lc">📍 ' + esc(r.l) + '</div></div></div>'


        + reviewBadges() + '</div>';


    }).join('') + '</div>';


  }





  /* Best-guess category for a product, from its tags then title. Used to keep


     product-sheet reviews on-topic (birthday reviews on birthday setups, etc.).


     Returns null when nothing matches → neutral reviews only. */


  function catForProduct(p) {


    var hay = ((p.title || '') + ' ' + (p.tagsLc || []).join(' ')).toLowerCase();


    if (/anniversar/.test(hay))                       return 'anniversary';


    if (/romantic|romance|first night|honeymoon/.test(hay)) return 'romantic';


    if (/baby shower/.test(hay))                      return 'baby';


    if (/welcome baby|newborn|baby welcome/.test(hay)) return 'welcome';


    if (/wedding|bride|groom|engagement/.test(hay))   return 'bride';


    if (/theme|character|spiderman|barbie|unicorn|mermaid|avenger/.test(hay)) return 'theme';


    if (/birthday/.test(hay))                         return 'birthday';


    return null;


  }





  /* Reviews block for the product sheet — shows reviews for THIS product,


     localised to the currently selected city and relevant to its occasion. */


  function productReviewsHTML(p) {


    var seed    = hashStr(p.id);


    var count   = 12 + (seed % 4);             /* 12–15 reviews */


    var list    = pickReviewsFor(seed, count, currentCity, catForProduct(p));


    var sum      = list.reduce(function (s, r) { return s + r.r; }, 0);


    var avg      = (sum / list.length).toFixed(1);


    return ''


      + '<div class="tbw-ps-sec tbw-ps-sec--reviews">'


      + '<div class="tbw-ps-reviews" style="margin-top:0">'


      + '<div style="display:flex;align-items:center;justify-content:space-between;margin-bottom:10px">'


      + '<h3 style="font-size:14px;font-weight:700;color:var(--ink);margin:0">Reviews in ' + esc(currentCity) + '</h3>'


      + '<span style="font-size:12px;color:var(--muted);font-weight:300"><span style="color:#e8a030">★</span> ' + avg + '</span>'


      + '</div>'


      + reviewCarousel(list)


      + '</div>'
      + '</div>';


  }





  var HOME_SECTIONS = [


    { key: 'birthday',    title: 'Birthday Decorations',    icon: '🎂', grad: '#fff0e8,#ffddd0' },


    { key: 'backdrop',    title: 'Birthday Theme Backdrops', icon: '🎭', grad: '#fff0f8,#ffd6f0' },


    { key: 'anniversary', title: 'Anniversary Setups',      icon: '💕', grad: '#fff8e0,#ffe0a0' },


    { key: 'romantic',    title: 'Romantic Room Decor',     icon: '🌹', grad: '#fff0f8,#ffc8e8' },


    { key: 'baby',        title: 'Baby Shower',             icon: '🍼', grad: '#f0f8ff,#c8e0ff' },


    { key: 'welcome',     title: 'Welcome Baby',            icon: '👶', grad: '#f0fff0,#c8f0c8' },


    { key: 'theme',       title: 'Kids & Themed',           icon: '🎭', grad: '#fffbf0,#ffe8c0' },


    { key: 'bride',       title: 'Wedding · Bride & Groom',  icon: '💍', grad: '#f8f0ff,#e0c8ff' }


  ];





  /* Premium ring decorations are only offered in these cities, so the section


     is shown on Home only when one of them is selected. */


  var RING_CITIES = ['bangalore', 'surat', 'pune', 'hyderabad'];





  function homeSectionsForCity() {


    var list = HOME_SECTIONS.slice();

    var city = (currentCity || '').toLowerCase();

    var at = 1; /* running insert position right after Birthday */

    /* Balloon Bouquets — new gift category, Home section in launch cities only. */

    if (BOUQUET_CITIES.indexOf(city) > -1) {

      list.splice(at, 0, { key: 'bouquet', title: 'Balloon Bouquets', icon: '🎈', grad: '#fff0f4,#ffd6e4' });

      at += 1;

    }


    if (RING_CITIES.indexOf(city) > -1) {


      /* Insert right after Birthday so the premium section sits near the top. */


      list.splice(at, 0, { key: 'ring', title: 'Premium Birthday Ring Decoration', icon: '💎', grad: '#fff7e6,#ffe3a8' });


    }


    return list;


  }





  function renderHomeSections() {

    tbwBqNavSync(); /* boot + every city change rebuilds Home — keep the Bouquets tab city-gated */

    var host = document.getElementById('tbw-home-sections');


    if (!host) return;


    var sections = homeSectionsForCity();


    /* Lay out an ordered placeholder per section, then fill each as its


       collection resolves — sections appear progressively (faster perceived load). */


    host.innerHTML = sections.map(function (s, i) {


      return '<div id="tbw-hs-' + i + '"><div class="tbw-sk" style="height:230px;border-radius:14px;margin:16px 18px"></div></div>';


    }).join('');


    sections.forEach(function (s, i) {


      fetchCollection(s.key).then(function (products) {


        var slot = document.getElementById('tbw-hs-' + i);


        if (!slot) return;


        var prods = visibleProducts(products).slice(0, 8); /* already price-asc */


        if (!prods.length) { slot.innerHTML = ''; return; }


        slot.innerHTML =


            '<div class="tbw-sh tbw-sh--cat">'


          + '<div class="tbw-sh-head">'


          + '<span class="tbw-sh-ic" style="background:linear-gradient(135deg,' + s.grad + ')">' + s.icon + '</span>'


          + '<h2 class="tbw-sh-t">' + esc(s.title) + '</h2>'


          + '</div>'


          + '<span class="tbw-sh-l" onclick="tbwGoExplore(\'' + s.key + '\')">View all ›</span></div>'


          + '<div class="tbw-home-grid">' + prods.map(gridCard).join('') + '</div>'


          + '<button class="tbw-viewall" onclick="tbwGoExplore(\'' + s.key + '\')">View all ' + esc(s.title) + ' →</button>'


          + reviewCarousel(pickReviewsFor(hashStr(s.key), 4, currentCity, s.key));


        if (!lcpHinted) {


          var firstImg = slot.querySelector('.tbw-pcv-img1');


          if (firstImg) {


            firstImg.setAttribute('loading', 'eager');


            firstImg.setAttribute('fetchpriority', 'high');


            lcpHinted = true;


          }


        }


      });


    });


  }





  /* Category pill / "View all" → jump to Explore tab on that same category. */


  function goExplore(key) {


    /* Mark Explore as loaded BEFORE switching tabs so goTab()→loadExplore()


       doesn't fire a competing renderExplore('all'). Without this, the 'all'


       fetch could resolve after our category fetch and overwrite the grid with


       a shuffled all-category list (user then had to re-tap the pill). */


    exploreLoaded = true;


    goTab('explore');


    document.querySelectorAll('.tbw-fp:not(.tbw-fsub)').forEach(function (p) {


      p.classList.toggle('on', p.getAttribute('data-cat') === key);


    });


    var subRow = document.getElementById('tbw-fsub-row');
    var bqRow  = document.getElementById('tbw-fsub-row-bq');


    if (subRow) subRow.style.display = (key === 'birthday') ? 'flex' : 'none';
    if (bqRow)  bqRow.style.display  = (key === 'bouquet')  ? 'flex' : 'none';


    if (key === 'birthday') {


      document.querySelectorAll('#tbw-fsub-row .tbw-fsub').forEach(function(p){ p.classList.toggle('on', p.getAttribute('data-subcat') === 'all'); });


    }


    if (key === 'bouquet') {


      document.querySelectorAll('#tbw-fsub-row-bq .tbw-fsub').forEach(function(p){ p.classList.toggle('on', p.getAttribute('data-bqsub') === 'all'); });


    }


    if (TAG_CATS[key]) {


      renderExploreByTags(key, key === 'birthday' ? BIRTHDAY_SUB.all : TAG_CATS[key]);


    } else {


      renderExplore(key);


    }


    var sw = document.getElementById('tbw-sw');


    if (sw) sw.scrollTop = 0;


  }


  window.tbwGoExplore = goExplore;





  function setCat(el, key) { goExplore(key); }


  window.tbwSetCat = setCat;





  function onHomeSearch(q) {


    var lq       = q.toLowerCase().trim();


    var results  = document.getElementById('tbw-home-search-results');


    var sections = document.getElementById('tbw-home-sections');


    if (!lq) {


      if (results)  { results.style.display = 'none'; results.innerHTML = ''; }


      if (sections) sections.style.display = '';


      return;


    }


    fetchAllForSearch().then(function (products) {


      var matched = visibleProducts(products).filter(function (p) {


        return p.title.toLowerCase().indexOf(lq) > -1


            || p.tagsLc.some(function (t) { return t.indexOf(lq) > -1; });


      });


      if (sections) sections.style.display = 'none';


      if (!results) return;


      results.style.display = 'block';


      results.innerHTML =


        '<div class="tbw-sh" style="margin-top:10px"><h2 class="tbw-sh-t">'


        + matched.length + ' result' + (matched.length === 1 ? '' : 's') + ' for "' + esc(q) + '"</h2></div>'


        + (matched.length


            ? '<div class="tbw-home-grid">' + matched.slice(0, 30).map(gridCard).join('') + '</div>'


            : '<div style="padding:30px 18px;text-align:center;color:var(--muted);font-size:13px">No setups match. Try a different word.</div>');


    });


  }


  window.tbwOnHomeSearch = onHomeSearch;





  /* ================================================================


     EXPLORE SCREEN


  ================================================================ */


  var exploreLoaded = false;


  var exploreCat    = 'all';


  var lcpHinted     = false;





  function loadExplore() {


    if (exploreLoaded) return;


    exploreLoaded = true;


    renderExplore('all');


  }





  function renderExplore(key) {


    exploreCat = key;
    tbwGalBtnSync();


    var sk = exploreSkeleton();


    var grid = document.getElementById('tbw-exp-grid');


    var list = document.getElementById('tbw-exp-list');


    var count = document.getElementById('tbw-exp-count');


    if (grid) grid.innerHTML = sk.grid;


    if (list) list.innerHTML = '';





    fetchCollection(key).then(function(products){


      var prods = visibleProducts(products); /* already price-asc */


      if (count) count.textContent = prods.length + ' Setups';


      if (grid) grid.innerHTML = prods.length


        ? prods.map(gridCard).join('')


        : '<div style="grid-column:1/-1;padding:30px;text-align:center;color:var(--muted);font-size:13px">No setups found</div>';


      if (list) list.innerHTML = '';


    });


  }





  function renderExploreByTags(catKey, tags) {


    exploreCat = catKey;
    tbwGalBtnSync();


    var sk = exploreSkeleton();


    var grid = document.getElementById('tbw-exp-grid');


    var list = document.getElementById('tbw-exp-list');


    var count = document.getElementById('tbw-exp-count');


    if (grid) grid.innerHTML = sk.grid;


    if (list) list.innerHTML = '';


    var tagsLc = tags.map(function(t){ return t.toLowerCase(); });


    fetchAllForSearch().then(function(products){


      var prods = visibleProducts(products).filter(function(p){


        return tagsLc.some(function(tag){ return p.tagsLc.indexOf(tag) > -1; });


      });


      if (count) count.textContent = prods.length + ' Setups';


      if (grid) grid.innerHTML = prods.length


        ? prods.map(gridCard).join('')


        : '<div style="grid-column:1/-1;padding:30px;text-align:center;color:var(--muted);font-size:13px">No setups found</div>';


      if (list) list.innerHTML = '';


    });


  }





  function filterExp(el, key) {


    document.querySelectorAll('.tbw-fp:not(.tbw-fsub)').forEach(function(p){ p.classList.remove('on'); });


    el.classList.add('on');


    var srch = document.getElementById('tbw-exp-srch');


    if (srch) srch.value = '';


    var subRow = document.getElementById('tbw-fsub-row');
    var bqRow  = document.getElementById('tbw-fsub-row-bq');


    if (subRow) subRow.style.display = (key === 'birthday') ? 'flex' : 'none';
    if (bqRow)  bqRow.style.display  = (key === 'bouquet')  ? 'flex' : 'none';


    if (key === 'birthday') {


      document.querySelectorAll('#tbw-fsub-row .tbw-fsub').forEach(function(p){ p.classList.toggle('on', p.getAttribute('data-subcat') === 'all'); });


    }


    if (key === 'bouquet') {


      document.querySelectorAll('#tbw-fsub-row-bq .tbw-fsub').forEach(function(p){ p.classList.toggle('on', p.getAttribute('data-bqsub') === 'all'); });


    }


    if (TAG_CATS[key]) {


      renderExploreByTags(key, key === 'birthday' ? BIRTHDAY_SUB.all : TAG_CATS[key]);


    } else {


      renderExplore(key);


    }


  }


  window.tbwFilterExp = filterExp;





  function filterSub(el, subKey) {


    document.querySelectorAll('.tbw-fsub').forEach(function(p){ p.classList.remove('on'); });


    el.classList.add('on');


    renderExploreByTags('birthday', BIRTHDAY_SUB[subKey] || BIRTHDAY_SUB.all);


  }


  window.tbwFilterSub = filterSub;


  function filterSubBq(el, subKey) {
    document.querySelectorAll('#tbw-fsub-row-bq .tbw-fsub').forEach(function(p){ p.classList.remove('on'); });
    el.classList.add('on');
    renderExploreByTags('bouquet', BOUQUET_SUB[subKey] || BOUQUET_SUB.all);
  }
  window.tbwFilterSubBq = filterSubBq;





  function onExpSearch(q) {


    var lq = q.toLowerCase().trim();


    if (!lq) { renderExplore(exploreCat); return; }


    /* Universal search: always search the FULL catalogue, never just the


       currently-selected category. So "batman" while on Anniversary still finds


       the themed setup instead of wrongly reporting "no products". */


    fetchAllForSearch().then(function(products){


      var filtered = visibleProducts(products).filter(function(p){


        return p.title.toLowerCase().indexOf(lq) > -1 || p.tagsLc.some(function(t){ return t.indexOf(lq) > -1; });


      });


      var count = document.getElementById('tbw-exp-count');


      if (count) count.textContent = filtered.length + ' result' + (filtered.length === 1 ? '' : 's') + ' (all categories)';


      var grid = document.getElementById('tbw-exp-grid');


      var list = document.getElementById('tbw-exp-list');


      if (grid) grid.innerHTML = filtered.length


        ? filtered.map(gridCard).join('')


        : '<div style="grid-column:1/-1;padding:30px;text-align:center;color:var(--muted);font-size:13px">No results</div>';


      if (list) list.innerHTML = '';


    });


  }


  window.tbwOnExpSearch = onExpSearch;





  /* ================================================================


     PRODUCT SHEET


     Products are looked up from cache (already loaded when browsing).


     Falls back to direct API fetch if somehow not cached.


  ================================================================ */


  function findProduct(id) {


    /* Search all cached collections */


    var keys = Object.keys(cache);


    for (var i = 0; i < keys.length; i++) {


      var found = cache[keys[i]].find(function(p){ return p.id === id; });


      if (found) return Promise.resolve(found);


    }


    /* Not in cache — fetch by handle via storefront */


    return fetch('/products.json?limit=250')


      .then(function(r){ return r.json(); })


      .then(function(data){


        return (data.products || []).map(normalize).find(function(p){ return p.id === id; }) || null;


      });


  }





  function findProductByHandle(handle) {


    var keys = Object.keys(cache);


    for (var i = 0; i < keys.length; i++) {


      var found = cache[keys[i]].find(function(p){ return p.handle === handle; });


      if (found) return Promise.resolve(found);


    }


    return fetch('/products/' + handle + '.json')


      .then(function(r){ return r.ok ? r.json() : null; })


      .then(function(data){


        var p = (data && data.product) ? normalize(data.product) : null;


        if (p) { cache['_deeplink'] = cache['_deeplink'] || []; cache['_deeplink'].push(p); }


        return p;


      })


      .catch(function(){ return null; });


  }





  /* ---- Balloon Bouquet recent-deliveries gallery — Rishi 2026-11-03 ----
     Real photos from "Recent done Bouquet" (100 uploads, Shopify Files). */

  var BQ_GALLERY = [
    "https://cdn.shopify.com/s/files/1/0823/6502/2520/files/bouquet-recent-001.jpg?v=1793643683",
    "https://cdn.shopify.com/s/files/1/0823/6502/2520/files/bouquet-recent-002.jpg?v=1793643685",
    "https://cdn.shopify.com/s/files/1/0823/6502/2520/files/bouquet-recent-003.jpg?v=1793643687",
    "https://cdn.shopify.com/s/files/1/0823/6502/2520/files/bouquet-recent-004.jpg?v=1793643690",
    "https://cdn.shopify.com/s/files/1/0823/6502/2520/files/bouquet-recent-005.jpg?v=1793643692",
    "https://cdn.shopify.com/s/files/1/0823/6502/2520/files/bouquet-recent-006.jpg?v=1793643694",
    "https://cdn.shopify.com/s/files/1/0823/6502/2520/files/bouquet-recent-007.jpg?v=1793643696",
    "https://cdn.shopify.com/s/files/1/0823/6502/2520/files/bouquet-recent-008.jpg?v=1793643699",
    "https://cdn.shopify.com/s/files/1/0823/6502/2520/files/bouquet-recent-009.jpg?v=1793643701",
    "https://cdn.shopify.com/s/files/1/0823/6502/2520/files/bouquet-recent-010.jpg?v=1793643703",
    "https://cdn.shopify.com/s/files/1/0823/6502/2520/files/bouquet-recent-011.jpg?v=1793643706",
    "https://cdn.shopify.com/s/files/1/0823/6502/2520/files/bouquet-recent-012.jpg?v=1793643708",
    "https://cdn.shopify.com/s/files/1/0823/6502/2520/files/bouquet-recent-013.jpg?v=1793643711",
    "https://cdn.shopify.com/s/files/1/0823/6502/2520/files/bouquet-recent-014.jpg?v=1793643713",
    "https://cdn.shopify.com/s/files/1/0823/6502/2520/files/bouquet-recent-015.jpg?v=1793643716",
    "https://cdn.shopify.com/s/files/1/0823/6502/2520/files/bouquet-recent-016.jpg?v=1793643719",
    "https://cdn.shopify.com/s/files/1/0823/6502/2520/files/bouquet-recent-017.jpg?v=1793643721",
    "https://cdn.shopify.com/s/files/1/0823/6502/2520/files/bouquet-recent-018.jpg?v=1793643723",
    "https://cdn.shopify.com/s/files/1/0823/6502/2520/files/bouquet-recent-019.jpg?v=1793643725",
    "https://cdn.shopify.com/s/files/1/0823/6502/2520/files/bouquet-recent-020.jpg?v=1793643728",
    "https://cdn.shopify.com/s/files/1/0823/6502/2520/files/bouquet-recent-021.jpg?v=1793643730",
    "https://cdn.shopify.com/s/files/1/0823/6502/2520/files/bouquet-recent-022.jpg?v=1793643732",
    "https://cdn.shopify.com/s/files/1/0823/6502/2520/files/bouquet-recent-023.jpg?v=1793643735",
    "https://cdn.shopify.com/s/files/1/0823/6502/2520/files/bouquet-recent-024.jpg?v=1793643737",
    "https://cdn.shopify.com/s/files/1/0823/6502/2520/files/bouquet-recent-025.jpg?v=1793643739",
    "https://cdn.shopify.com/s/files/1/0823/6502/2520/files/bouquet-recent-026.jpg?v=1793643741",
    "https://cdn.shopify.com/s/files/1/0823/6502/2520/files/bouquet-recent-027.jpg?v=1793643744",
    "https://cdn.shopify.com/s/files/1/0823/6502/2520/files/bouquet-recent-028.jpg?v=1793643746",
    "https://cdn.shopify.com/s/files/1/0823/6502/2520/files/bouquet-recent-029.jpg?v=1793643748",
    "https://cdn.shopify.com/s/files/1/0823/6502/2520/files/bouquet-recent-030.jpg?v=1793643750",
    "https://cdn.shopify.com/s/files/1/0823/6502/2520/files/bouquet-recent-031.jpg?v=1793643753",
    "https://cdn.shopify.com/s/files/1/0823/6502/2520/files/bouquet-recent-032.jpg?v=1793643757",
    "https://cdn.shopify.com/s/files/1/0823/6502/2520/files/bouquet-recent-033.jpg?v=1793643759",
    "https://cdn.shopify.com/s/files/1/0823/6502/2520/files/bouquet-recent-034.jpg?v=1793643761",
    "https://cdn.shopify.com/s/files/1/0823/6502/2520/files/bouquet-recent-035.jpg?v=1793643763",
    "https://cdn.shopify.com/s/files/1/0823/6502/2520/files/bouquet-recent-036.jpg?v=1793643766",
    "https://cdn.shopify.com/s/files/1/0823/6502/2520/files/bouquet-recent-037.jpg?v=1793643768",
    "https://cdn.shopify.com/s/files/1/0823/6502/2520/files/bouquet-recent-038.jpg?v=1793643770",
    "https://cdn.shopify.com/s/files/1/0823/6502/2520/files/bouquet-recent-039.jpg?v=1793643773",
    "https://cdn.shopify.com/s/files/1/0823/6502/2520/files/bouquet-recent-040.jpg?v=1793643775",
    "https://cdn.shopify.com/s/files/1/0823/6502/2520/files/bouquet-recent-041.jpg?v=1793643777",
    "https://cdn.shopify.com/s/files/1/0823/6502/2520/files/bouquet-recent-042.jpg?v=1793643780",
    "https://cdn.shopify.com/s/files/1/0823/6502/2520/files/bouquet-recent-043.jpg?v=1793643782",
    "https://cdn.shopify.com/s/files/1/0823/6502/2520/files/bouquet-recent-044.jpg?v=1793643784",
    "https://cdn.shopify.com/s/files/1/0823/6502/2520/files/bouquet-recent-045.jpg?v=1793643786",
    "https://cdn.shopify.com/s/files/1/0823/6502/2520/files/bouquet-recent-046.jpg?v=1793643789",
    "https://cdn.shopify.com/s/files/1/0823/6502/2520/files/bouquet-recent-047.jpg?v=1793643791",
    "https://cdn.shopify.com/s/files/1/0823/6502/2520/files/bouquet-recent-048.jpg?v=1793643793",
    "https://cdn.shopify.com/s/files/1/0823/6502/2520/files/bouquet-recent-049.jpg?v=1793643796",
    "https://cdn.shopify.com/s/files/1/0823/6502/2520/files/bouquet-recent-050.jpg?v=1793643798",
    "https://cdn.shopify.com/s/files/1/0823/6502/2520/files/bouquet-recent-051.jpg?v=1793643801",
    "https://cdn.shopify.com/s/files/1/0823/6502/2520/files/bouquet-recent-052.jpg?v=1793643803",
    "https://cdn.shopify.com/s/files/1/0823/6502/2520/files/bouquet-recent-053.jpg?v=1793643806",
    "https://cdn.shopify.com/s/files/1/0823/6502/2520/files/bouquet-recent-054.jpg?v=1793643808",
    "https://cdn.shopify.com/s/files/1/0823/6502/2520/files/bouquet-recent-055.jpg?v=1793643810",
    "https://cdn.shopify.com/s/files/1/0823/6502/2520/files/bouquet-recent-056.jpg?v=1793643813",
    "https://cdn.shopify.com/s/files/1/0823/6502/2520/files/bouquet-recent-057.jpg?v=1793643815",
    "https://cdn.shopify.com/s/files/1/0823/6502/2520/files/bouquet-recent-058.jpg?v=1793643817",
    "https://cdn.shopify.com/s/files/1/0823/6502/2520/files/bouquet-recent-059.jpg?v=1793643820",
    "https://cdn.shopify.com/s/files/1/0823/6502/2520/files/bouquet-recent-060.jpg?v=1793643822",
    "https://cdn.shopify.com/s/files/1/0823/6502/2520/files/bouquet-recent-061.jpg?v=1793643825",
    "https://cdn.shopify.com/s/files/1/0823/6502/2520/files/bouquet-recent-062.jpg?v=1793643827",
    "https://cdn.shopify.com/s/files/1/0823/6502/2520/files/bouquet-recent-063.jpg?v=1793643830",
    "https://cdn.shopify.com/s/files/1/0823/6502/2520/files/bouquet-recent-064.jpg?v=1793643832",
    "https://cdn.shopify.com/s/files/1/0823/6502/2520/files/bouquet-recent-065.jpg?v=1793643834",
    "https://cdn.shopify.com/s/files/1/0823/6502/2520/files/bouquet-recent-066.jpg?v=1793643837",
    "https://cdn.shopify.com/s/files/1/0823/6502/2520/files/bouquet-recent-067.jpg?v=1793643839",
    "https://cdn.shopify.com/s/files/1/0823/6502/2520/files/bouquet-recent-068.jpg?v=1793643842",
    "https://cdn.shopify.com/s/files/1/0823/6502/2520/files/bouquet-recent-069.jpg?v=1793643844",
    "https://cdn.shopify.com/s/files/1/0823/6502/2520/files/bouquet-recent-070.jpg?v=1793643846",
    "https://cdn.shopify.com/s/files/1/0823/6502/2520/files/bouquet-recent-071.jpg?v=1793643848",
    "https://cdn.shopify.com/s/files/1/0823/6502/2520/files/bouquet-recent-072.jpg?v=1793643850",
    "https://cdn.shopify.com/s/files/1/0823/6502/2520/files/bouquet-recent-073.jpg?v=1793643854",
    "https://cdn.shopify.com/s/files/1/0823/6502/2520/files/bouquet-recent-074.jpg?v=1793643856",
    "https://cdn.shopify.com/s/files/1/0823/6502/2520/files/bouquet-recent-075.jpg?v=1793643859",
    "https://cdn.shopify.com/s/files/1/0823/6502/2520/files/bouquet-recent-076.jpg?v=1793643861",
    "https://cdn.shopify.com/s/files/1/0823/6502/2520/files/bouquet-recent-077.jpg?v=1793643863",
    "https://cdn.shopify.com/s/files/1/0823/6502/2520/files/bouquet-recent-078.jpg?v=1793643865",
    "https://cdn.shopify.com/s/files/1/0823/6502/2520/files/bouquet-recent-079.jpg?v=1793643868",
    "https://cdn.shopify.com/s/files/1/0823/6502/2520/files/bouquet-recent-080.jpg?v=1793643870",
    "https://cdn.shopify.com/s/files/1/0823/6502/2520/files/bouquet-recent-081.jpg?v=1793643872",
    "https://cdn.shopify.com/s/files/1/0823/6502/2520/files/bouquet-recent-082.jpg?v=1793643875",
    "https://cdn.shopify.com/s/files/1/0823/6502/2520/files/bouquet-recent-083.jpg?v=1793643877",
    "https://cdn.shopify.com/s/files/1/0823/6502/2520/files/bouquet-recent-084.jpg?v=1793643879",
    "https://cdn.shopify.com/s/files/1/0823/6502/2520/files/bouquet-recent-085.jpg?v=1793643881",
    "https://cdn.shopify.com/s/files/1/0823/6502/2520/files/bouquet-recent-086.jpg?v=1793643883",
    "https://cdn.shopify.com/s/files/1/0823/6502/2520/files/bouquet-recent-087.jpg?v=1793643886",
    "https://cdn.shopify.com/s/files/1/0823/6502/2520/files/bouquet-recent-088.jpg?v=1793643888",
    "https://cdn.shopify.com/s/files/1/0823/6502/2520/files/bouquet-recent-089.jpg?v=1793643890",
    "https://cdn.shopify.com/s/files/1/0823/6502/2520/files/bouquet-recent-090.jpg?v=1793643893",
    "https://cdn.shopify.com/s/files/1/0823/6502/2520/files/bouquet-recent-091.jpg?v=1793643896",
    "https://cdn.shopify.com/s/files/1/0823/6502/2520/files/bouquet-recent-092.jpg?v=1793643898",
    "https://cdn.shopify.com/s/files/1/0823/6502/2520/files/bouquet-recent-093.jpg?v=1793643900",
    "https://cdn.shopify.com/s/files/1/0823/6502/2520/files/bouquet-recent-094.jpg?v=1793643902",
    "https://cdn.shopify.com/s/files/1/0823/6502/2520/files/bouquet-recent-095.jpg?v=1793643905",
    "https://cdn.shopify.com/s/files/1/0823/6502/2520/files/bouquet-recent-096.jpg?v=1793643908",
    "https://cdn.shopify.com/s/files/1/0823/6502/2520/files/bouquet-recent-097.jpg?v=1793643910",
    "https://cdn.shopify.com/s/files/1/0823/6502/2520/files/bouquet-recent-098.jpg?v=1793643912",
    "https://cdn.shopify.com/s/files/1/0823/6502/2520/files/bouquet-recent-099.jpg?v=1793643915",
    "https://cdn.shopify.com/s/files/1/0823/6502/2520/files/bouquet-recent-100.jpg?v=1793643917"
  ];

  function bqImg(u, w) {
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w + '&format=webp';
  }

  var bqGalBuilt = false;
  function tbwOpenBqGal() {
    var g = document.getElementById('tbw-bq-gal');
    var body = document.getElementById('tbw-bq-gal-body');
    if (!g || !body) return;
    if (!bqGalBuilt) {
      body.innerHTML = '<div class="tbw-bq-gal-grid">' + BQ_GALLERY.map(function(u, i) {
        return '<img loading="lazy" src="' + bqImg(u, 420) + '" alt="Recent balloon bouquet delivery ' + (i + 1) + ' by TheBalloonwala">';
      }).join('') + '</div>';
      bqGalBuilt = true;
    }
    g.classList.add('open');
    document.body.style.overflow = 'hidden';
    if (window.dataLayer) window.dataLayer.push({ event: 'bouquet_gallery_open' });
  }
  window.tbwOpenBqGal = tbwOpenBqGal;

  function tbwCloseBqGal() {
    var g = document.getElementById('tbw-bq-gal');
    if (!g) return;
    g.classList.remove('open');
    document.body.style.overflow = '';
  }
  window.tbwCloseBqGal = tbwCloseBqGal;

  /* show the gallery chip only while the bouquet category is active in Explore
     AND the current city is a live bouquet city (no chip over a 0-product category) */
  function tbwGalBtnSync() {
    var b = document.getElementById('tbw-bq-gal-btn');
    var cityOk = BOUQUET_CITIES.indexOf((currentCity || '').toLowerCase()) > -1;
    if (b) b.style.display = (exploreCat === 'bouquet' && cityOk) ? 'flex' : 'none';
  }

  /* bottom-nav Bouquets tab: only in live bouquet cities (Rishi 2026-11-03 —
     other cities showed a category with 0 products) */
  function tbwBqNavSync() {
    var t = document.getElementById('tbw-t-bouquet');
    var cityOk = BOUQUET_CITIES.indexOf((currentCity || '').toLowerCase()) > -1;
    if (t) t.style.display = cityOk ? '' : 'none';
  }

  /* ---- Balloon Bouquet description accordion — Rishi 2026-11-02 v2 ----
     Splits sanitized body_html on h2/h3 headings; renders one collapsible
     card per heading (icon chip + title + arrow), styled like the native
     .tbw-ps-sec--details section cards. */

  var tbwFullCache = {};

  function tbwToggleAcc(hdr) {
    var card = hdr && hdr.parentElement;
    if (card) card.classList.toggle('open');
  }
  window.tbwToggleAcc = tbwToggleAcc;

  function tbwSanitizeBody(h) {
    var t = document.createElement('div');
    t.innerHTML = h || '';
    try {
      t.querySelectorAll('script,style,iframe,img,form,input,button,video,object,embed,link,meta').forEach(function(n){ n.remove(); });
      var all = t.querySelectorAll('*');
      for (var i = 0; i < all.length; i++) {
        var attrs = Array.prototype.slice.call(all[i].attributes || []);
        for (var j = 0; j < attrs.length; j++) {
          if (/^on/i.test(attrs[j].name)) all[i].removeAttribute(attrs[j].name);
        }
      }
    } catch (e) { /* best-effort sanitize */ }
    return t;
  }

  function tbwAccIcon(title) {
    var t = (title || '').toLowerCase();
    if (/gift|surprise/.test(t)) return '🎁';
    if (/why you|love|why you'll/.test(t)) return '✨';
    if (/good to know|before you order|know before/.test(t)) return '📋';
    if (/care|last|keep|fresh/.test(t)) return '🎈';
    if (/deliver|shipping|reach/.test(t)) return '🚚';
    if (/cancel|reschedul|refund|change/.test(t)) return '↩️';
    if (/faq|question|q&a/.test(t)) return '❓';
    if (/customis|customiz|personalis/.test(t)) return '✏️';
    if (/price|pay|prepaid/.test(t)) return '💳';
    return '📖';
  }

  function tbwBuildAcc(sanitizedRoot) {
    var sections = [], cur = null;
    Array.prototype.forEach.call(sanitizedRoot.childNodes, function(node) {
      var tag = (node.nodeName || '').toLowerCase();
      if (tag === 'h2' || tag === 'h3' || tag === 'h4') {
        var txt = (node.textContent || '').trim();
        if (txt) { cur = { title: txt, html: '' }; sections.push(cur); }
        return;
      }
      if (!cur) cur = { title: '', html: '' }, sections.push(cur);
      cur.html += node.nodeType === 1 ? node.outerHTML : '';
    });
    return sections.filter(function(s) {
      var hasBody = /[a-z0-9]/i.test(s.html.replace(/<[^>]+>/g, ''));
      return s.title || hasBody;
    }).map(function(s, i) {
      var title = s.title || 'About This Bouquet';
      var body = s.html.trim();
      if (!body && s.title) body = '';
      return '<div class="tbw-ps-sec tbw-ps-sec--details tbw-bq-acc-item">'
        + '<div class="tbw-ps-sec-hdr tbw-bq-acc-hdr" onclick="tbwToggleAcc(this)">'
        + '<div class="tbw-ps-sec-ic">' + tbwAccIcon(title) + '</div>'
        + '<span class="tbw-bq-acc-t">' + esc(title) + '</span>'
        + '<span class="tbw-bq-full-ar">▾</span>'
        + '</div>'
        + '<div class="tbw-bq-acc-body">' + body + '</div>'
        + '</div>';
    }).join('');
  }

  function tbwLoadFullDetails(handle) {
    var host = document.getElementById('tbw-bq-acc');
    if (!host || !handle) return;
    if (tbwFullCache[handle] !== undefined) { host.outerHTML = '<div id="tbw-bq-acc">' + tbwFullCache[handle] + '</div>'; return; }
    fetch('/products/' + handle + '.js').then(function(r){ return r.json(); }).then(function(pr) {
      var root = tbwSanitizeBody(pr.description || '');
      var cards = tbwBuildAcc(root);
      tbwFullCache[handle] = cards;
      var h2 = document.getElementById('tbw-bq-acc');
      if (h2) h2.outerHTML = '<div id="tbw-bq-acc">' + cards + '</div>';
    }).catch(function(){
      var h3 = document.getElementById('tbw-bq-acc');
      if (h3) h3.innerHTML = '<p style="font-size:12px;color:var(--muted)">Full details are on the product page — tap the product title.</p>';
    });
  }

  function openSheet(id) {


    var psEl   = document.getElementById('tbw-ps');


    var body   = document.getElementById('tbw-ps-body');


    var ctas   = document.getElementById('tbw-ps-ctas');


    if (!psEl || !body || !ctas) return;





    /* Show loading state immediately */


    body.innerHTML = '<div style="padding:20px 0">'


      + '<div class="tbw-sk" style="width:100%;height:260px;border-radius:14px;margin-bottom:14px"></div>'


      + '<div class="tbw-sk" style="width:70%;height:20px;border-radius:6px;margin-bottom:10px"></div>'


      + '<div class="tbw-sk" style="width:40%;height:16px;border-radius:6px"></div>'


      + '</div>';


    ctas.innerHTML = '';


    psEl.classList.add('open');
    showSwipeHint();


    document.getElementById('tbw-ps-body').scrollTop = 0;


    var shell = document.getElementById('tbw-shell');


    if (shell) { shell.style.filter = 'blur(8px)'; shell.style.pointerEvents = 'none'; }


    if (window.location.hash !== '#tbw-sheet') { window.location.hash = 'tbw-sheet'; }





    if (window.dataLayer) window.dataLayer.push({ event: 'view_item', ecommerce: { items: [{ item_id: id }] } });





    findProduct(id).then(function(p){


      if (!p) { body.innerHTML = '<div style="padding:30px;text-align:center;color:var(--muted)">Product not found.</div>'; return; }


      renderSheet(p, body, ctas);


    });


  }


  window.tbwOpenSheet = openSheet;





  function getUrgencyHTML() {
    var key = 'tbw_urgency_start';
    var now = Date.now();
    var start;
    try { start = parseInt(localStorage.getItem(key) || '0', 10); } catch(e){ start = 0; }
    if (!start) {
      start = now;
      try { localStorage.setItem(key, String(start)); } catch(e){}
    }
    var elapsed = now - start;
    var window24 = 24 * 60 * 60 * 1000;
    if (elapsed >= window24) {
      try { localStorage.removeItem(key); } catch(e){}
      return '';
    }
    var remaining = window24 - elapsed;
    var hrs = Math.floor(remaining / 3600000);
    var mins = Math.floor((remaining % 3600000) / 60000);
    return '<div class="tbw-urgency" id="tbw-urgency-bar">'
      + '<span class="tbw-urgency-ic">⏰</span>'
      + '<div class="tbw-urgency-txt">'
      + '<strong>₹150 OFF</strong> if you book within '
      + '<span id="tbw-urgency-time">' + hrs + 'h ' + mins + 'm</span>'
      + ' — Use code <strong class="tbw-urgency-code">HURRY150</strong>'
      + '</div>'
      + '</div>';
  }


  function renderSheet(p, body, ctas) {


    pushRecent(p);


    /* Reset any variant picked in a previously-open sheet so a fresh sheet
       always defaults to THIS product's base variant, never a stale one. */
    window.tbwSelectedVariantId = null;


    /* Balloon Bouquet products: prepaid-only category — no add-on chips, no COD
       messaging, collapsible full description, prepaid pill (Rishi 2026-11-02). */
    var isBq = (p.tagsLc || []).indexOf('balloon bouquet') > -1;
    window.tbwSheetIsBq = isBq;


    var galleryImgs = (p.images && p.images.length > 0) ? p.images.slice(0, 8) : [];


    body.innerHTML = ''


      /* Swipeable image gallery (multi-image) or single image fallback */


      + (galleryImgs.length > 1


          ? '<div id="tbw-ps-gal" class="tbw-ps-gal">'


            + galleryImgs.map(function(src) {


                return '<div class="tbw-ps-gal-item">'


                  + '<img src="' + esc(addW(src, 800)) + '" alt="' + esc(p.title) + '" onerror="this.style.display=\'none\'"/>'


                  + '</div>';


              }).join('')


            + '</div>'


            + '<div class="tbw-ps-thumbs">'


            + galleryImgs.map(function(src, idx) {


                return '<div class="tbw-ps-thumb' + (idx === 0 ? ' on' : '') + '"'


                  + ' onclick="tbwScrollGal(' + idx + ')">'


                  + '<img src="' + esc(addW(src, 160)) + '" loading="lazy" alt=""/></div>';


              }).join('')


            + '</div>'


          : '<div class="tbw-ps-main-img">'


            + (p.imgFull ? '<img src="' + esc(p.imgFull) + '" alt="' + esc(p.title) + '" onerror="this.style.display=\'none\'"/>' : '')


            + '</div>')


      /* Name & price */


      + '<h2 class="tbw-ps-nm">' + esc(p.title) + '</h2>'


      + '<div class="tbw-ps-pr-row">'


      + '<div class="tbw-ps-pr" id="tbw-ps-price">' + fmt(p.price) + '</div>'


      + '</div>'


      /* Variant selector — only rendered for products with 2+ real variants
         (e.g. "No. of Balloons" sized by area). Picking a row updates the
         price above and which variant Add to Cart will actually add. */


      + (p.hasVariants
          ? '<div class="tbw-ps-sec tbw-ps-sec--details" id="tbw-ps-variant-sec">'
            + '<div class="tbw-ps-sec-hdr"><div class="tbw-ps-sec-ic">🎈</div>Choose ' + esc(p.optionName || 'an Option') + '</div>'
            + '<div class="tbw-vp-list" id="tbw-vp-list">'
            + p.variants.map(function (v, idx) {
                var parts = splitVariantOption(v.option1 || v.title);
                var unit  = variantUnitLabel(p.optionName);
                return '<div class="tbw-vp-opt' + (idx === 0 ? ' on' : '') + (v.available ? '' : ' tbw-vp-opt--soldout') + '"'
                  + ' data-vid="' + esc(v.id) + '"'
                  + (v.available ? ' onclick="tbwSelectVariant(this,\'' + esc(v.id) + '\',' + v.price + ')"' : '')
                  + '>'
                  + '<div class="tbw-vp-opt-main">'
                  + '<div class="tbw-vp-opt-t">' + esc(parts.main) + (unit ? ' <span class="tbw-vp-opt-unit">' + esc(unit) + '</span>' : '') + '</div>'
                  + (parts.sub ? '<div class="tbw-vp-opt-s">' + esc(parts.sub) + '</div>' : '')
                  + '</div>'
                  + '<div class="tbw-vp-opt-pr">' + (v.available ? fmt(v.price) : 'Sold out') + '</div>'
                  + '</div>';
              }).join('')
            + '</div>'
            + '</div>'
          : '')


      /* Rating */


      + '<div class="tbw-ps-rat"><span class="tbw-ps-stars">★★★★★</span><span>' + (isBq ? '4.9 · Professional setup · 100% prepaid' : '4.9 · Professional setup · COD available') + '</span></div>'


      /* Perks block */


      + '<div class="tbw-perks-block"><div class="tbw-perk-row"><div class="tbw-perk-icon tbw-perk-icon--red">💰</div><div><p class="tbw-perk-title">Best Pricing</p><p class="tbw-perk-sub">No inflated rates — this is the real price.</p></div></div>' + (isBq
        ? '<div class="tbw-perk-row"><div class="tbw-perk-icon tbw-perk-icon--teal">💳</div><div><p class="tbw-perk-title">100% Prepaid</p><p class="tbw-perk-sub">Balloon bouquets are prepaid — pay securely online at checkout.</p></div></div>'
        : '<div class="tbw-perk-row"><div class="tbw-perk-icon tbw-perk-icon--teal">💵</div><div><p class="tbw-perk-title">Cash on Delivery</p><p class="tbw-perk-sub">Pay after your setup is complete, not before.</p></div></div>') + '<div class="tbw-perk-row"><div class="tbw-perk-icon tbw-perk-icon--gold">💬</div><div><p class="tbw-perk-title">24×7 Human Support<span class="tbw-no-bot-tag">NO BOTS</span></p><p class="tbw-perk-sub">A real person on WhatsApp, any hour, any day.</p></div></div></div>'


      /* Short intro line (real product text, before the inclusions list) */


      + (!isBq && p.intro ? '<p class="tbw-ps-desc">' + esc(p.intro) + '</p>' : '')


      /* City-localised reviews — shown right after intro.
         Bouquets skip them (Rishi 2026-11-03): the shared review pool isn't
         bouquet-specific — the sheet leans on the real-deliveries gallery
         for social proof instead. */


      + (!isBq ? productReviewsHTML(p) : '')


      /* This Package Includes — REAL inclusions parsed from the product */


      /* Balloon Bouquets v2 (Rishi 2026-11-02): the Includes parser mis-reads
         bouquet bodies (partial gift-list text) — skip it; description renders
         as per-heading collapsible cards instead (tbw-bq-acc below). */

      + (!isBq && p.includes && p.includes.length


          ? '<div class="tbw-ps-sec tbw-ps-sec--details">'
            + '<div class="tbw-ps-sec-hdr"><div class="tbw-ps-sec-ic">🎁</div>This Package Includes</div>'
            + '<div class="tbw-ps-inc">'


            + p.includes.map(function(s){ return '<div class="tbw-ps-inc-i"><span class="tbw-ps-inc-d"></span>' + esc(s) + '</div>'; }).join('')


            + '</div>'
            + '</div>'


          : '')


      /* Bouquet description accordion — one collapsible card per body heading,
         styled like the native section cards; filled lazily by tbwLoadFullDetails. */

      + (isBq
          ? '<div id="tbw-bq-acc"><div class="tbw-sk" style="height:150px;border-radius:14px"></div></div>'
          : '')

      /* Recent real deliveries — trust gallery (bouquet sheets only) */

      + (isBq
          ? '<div class="tbw-ps-sec tbw-ps-sec--details tbw-bq-gal-card">'
            + '<div class="tbw-ps-sec-hdr"><div class="tbw-ps-sec-ic">📸</div>Our Recent Real Deliveries</div>'
            + '<p class="tbw-bq-gal-note">Not stock photos — actual setups our decorators delivered. Tap to browse.</p>'
            + '<div class="tbw-bq-gal-thumbs">'
            + BQ_GALLERY.slice(0, 4).map(function(u, i) {
                return '<img loading="lazy" src="' + bqImg(u, 220) + '" alt="Recent balloon bouquet delivery ' + (i + 1) + ' by TheBalloonwala">';
              }).join('')
            + '</div>'
            + '<button class="tbw-viewall" onclick="tbwOpenBqGal()">View all ' + BQ_GALLERY.length + ' real deliveries →</button>'
            + '</div>'
          : '')

      /* Customise */


      + '<div class="tbw-ps-sec tbw-ps-sec--details">'
      + '<div class="tbw-ps-sec-hdr"><div class="tbw-ps-sec-ic">✏️</div>Customise Your Decoration</div>'
      + '<div class="tbw-cust">'


      + '<h3>Customise This Design</h3>'


      + (isBq
          ? '<p>Tell us anything specific — colours, message on the card, occasion. Our team confirms everything on WhatsApp.</p>'
          : '<p>Tap options below, then describe anything specific — our team confirms on WhatsApp.</p>')


      + (isBq ? '' :
      '<div class="tbw-chips">'


      + [ ['Name','₹50 / letter'],['Age Balloons','₹50 small · ₹150 big / number'],['Fairy Light','₹200 / pc'],['Extra 50 Balloons','₹400'] ]


          .map(function(c){ return '<div class="tbw-chip" onclick="this.classList.toggle(\'on\');tbwAddonNote()"><span>' + c[0] + '</span><span style="display:block;font-size:9px;font-weight:400;opacity:.72;margin-top:1px">' + c[1] + '</span></div>'; }).join('')


      + '</div>'


      + '<div id="tbw-addon-note" style="display:none;font-size:11.5px;font-weight:500;margin-top:8px;line-height:1.5;background:#fdf6ec;border-left:3px solid #e0a458;border-radius:6px;padding:7px 9px;color:#7a5b20">💬 Add-on prices are indicative. After checkout, our team will WhatsApp you for the details (letters in the name, age &amp; size, number of fairy lights / extra balloons) and your final total including add-ons will be updated on WhatsApp.</div>'
      )


      + '<div class="tbw-ps-row">'


      + '<div><div class="tbw-flb">Your Pincode <span class="tbw-req">*</span></div><input class="tbw-ps-inp" id="tbw-sh-pin" type="tel" maxlength="6" placeholder="e.g. 560001" oninput="tbwPinCheck()" onblur="tbwPinCheck()"/></div>'


      + '<div><div class="tbw-flb">Event Date <span class="tbw-req">*</span></div><input class="tbw-ps-inp" id="tbw-sh-date" type="date" onchange="tbwDateNotice(this.value)"/></div>'


      + '<div id="tbw-conv-note" style="display:none;font-size:11.5px;font-weight:500;margin-top:6px;line-height:1.5;background:#fdf1ec;border-left:3px solid #e07850;border-radius:6px;padding:7px 9px;color:#8a4b2a">📍 This pincode is a bit far for our Bengaluru decorators — an extra conveyance of ₹300 will be added to your total.</div>'


      + '</div>'


      + ''


      + '<div style="margin-bottom:8px"><div class="tbw-flb">Setup Slot <span class="tbw-req">*</span></div>'


      + '<div id="tbw-sh-slots" tabindex="-1" style="display:flex;flex-wrap:wrap;gap:7px;padding:8px;border:1.5px solid transparent;border-radius:10px;margin-top:2px">'

      + ['10 AM – 12 PM','12 PM – 2 PM','2 PM – 4 PM','4 PM – 6 PM','6 PM – 8 PM','8 PM – 10 PM'].map(function(s, i){ return '<button type="button" class="tbw-slot" data-v="' + s + '" data-i="' + (i + 1) + '" onclick="tbwPickSlot(this)">' + s + '</button>'; }).join('')

      + '</div>'

      + '<div id="tbw-sameday-note" style="display:none;font-size:11.5px;font-weight:500;margin-top:6px;line-height:1.5;background:#e8f7ee;border-left:3px solid var(--green);border-radius:6px;padding:7px 9px;color:#14603a"></div>'

      + '<div id="tbw-delay-note" style="display:none;font-size:11px;color:var(--coral-d);font-weight:500;margin-top:5px">⚡ Slight delay may happen — our team finishes another setup first.</div>'

      + '<input type="hidden" id="tbw-sh-time" value=""/>'


      + '<div style="font-size:11px;color:var(--muted);font-weight:300;margin-top:4px">Pick a 2-hour window for your decoration setup.</div>'


      + ''


      + '</div>'


      + '<div class="tbw-flb">Customisation / Order Notes</div>'


      + '<textarea class="tbw-ps-ta" id="tbw-sh-msg" placeholder="e.g. Change blue to golden, add name \'Aryan\', add LED lights, gate number…"></textarea>'


      + '<p class="tbw-ps-hint">Share reference images on WhatsApp after connecting. <em>We can change any element.</em></p>'


      + '</div>'
      + '</div>'


      /* COD pill — bouquets swap to a prepaid pill (category is prepaid-only) */


      + (isBq
          ? '<div class="tbw-cod-pill tbw-cod-pill--prepaid"><span style="font-size:20px">💳</span><div><strong>100% Prepaid</strong><span>Balloon bouquets are prepaid only — pay securely online to confirm your order</span></div></div>'
          : '<div class="tbw-cod-pill"><span style="font-size:20px">✅</span><div><strong>Cash on Delivery</strong><span>Pay only after your setup is done and you love it</span></div></div>')


      ;





    ctas.innerHTML = getUrgencyHTML()


      + '<div class="tbw-ps-cta-row">'
      + '<button id="tbw-sh-add" class="tbw-btn-cart--primary tbw-btn-half" onclick="tbwAddToCart(\'' + esc(p.id) + '\', window.tbwSelectedVariantId || \'' + esc(p.vid) + '\')">🛒 Add to Cart</button>'
      + '<button class="tbw-btn-guide tbw-btn-half" onclick="tbwOpenBookingGuide(\'' + esc(p.id) + '\')">📋 How Booking Works</button>'
      + '</div>'


      + '<div class="tbw-ps-cta-note">' + (isBq ? '🔒 100% prepaid · Avg reply under 5 min' : 'Pay only after setup · Avg reply under 5 min') + '</div>';


    /* Bouquet sheet: lazily pull body_html and fill the collapsible details box */
    if (isBq) tbwLoadFullDetails(p.handle);

    (function startTicker() {
      var el = document.getElementById('tbw-urgency-time');
      if (!el) return;
      var key = 'tbw_urgency_start';
      var iv = setInterval(function(){
        var ps = document.getElementById('tbw-ps');
        if (!ps || !ps.classList.contains('open')) { clearInterval(iv); return; }
        var start = 0;
        try { start = parseInt(localStorage.getItem(key) || '0', 10); } catch(e){}
        if (!start) { clearInterval(iv); return; }
        var remaining = (24 * 3600000) - (Date.now() - start);
        if (remaining <= 0) {
          var bar = document.getElementById('tbw-urgency-bar');
          if (bar) bar.style.display = 'none';
          clearInterval(iv);
          return;
        }
        var hrs = Math.floor(remaining / 3600000);
        var mins = Math.floor((remaining % 3600000) / 60000);
        var timeEl = document.getElementById('tbw-urgency-time');
        if (timeEl) timeEl.textContent = hrs + 'h ' + mins + 'm';
      }, 30000);
    })();





    body.scrollTop = 0;


    addGalleryScrollSync();


    /* Peek-scroll: after sheet slides in, nudge 15% so user sees more content below */
    setTimeout(function() {
      var b = document.getElementById('tbw-ps-body');
      if (!b) return;
      var peek = Math.round(b.scrollHeight * 0.15);
      b.scrollTo({ top: peek, behavior: 'smooth' });
    }, 480);


  }





  function closePS() {


    var ps  = document.getElementById('tbw-ps');
    var pan = document.getElementById('tbw-ps-pan');


    if (!ps) return;


    /* Clear any inline transform/transition left by an interrupted swipe
       (e.g. Android back-gesture fires touchcancel, never touchend).
       Without this, panel.style.transition='none' blocks the CSS slide-out. */
    if (pan) { pan.style.transform = ''; pan.style.transition = ''; }


    ps.classList.remove('open');


    ps.classList.add('tbw-closing');


    var shell = document.getElementById('tbw-shell');


    if (shell) { shell.style.filter = ''; shell.style.pointerEvents = ''; }


    setTimeout(function() { ps.classList.remove('tbw-closing'); }, 420);


    /* Remove the hash entry we pushed when the sheet opened */


    if (window.location.hash === '#tbw-sheet') { _sheetHashBack = true; history.back(); }


  }


  window.tbwClosePS = closePS;


  /* ── BOOKING GUIDE SHEET (Change 4) ── */

  function closeGuide() {
    var guide = document.getElementById('tbw-guide');
    var pan   = document.getElementById('tbw-guide-pan');
    if (!guide) return;
    if (pan) { pan.style.transform = ''; pan.style.transition = ''; }
    guide.classList.remove('open');
    guide.classList.add('tbw-closing');
    setTimeout(function() { guide.classList.remove('tbw-closing'); }, 420);
    if (window.location.hash === '#tbw-guide-open') { _guideHashBack = true; history.back(); }
  }

  function bookingGuideHTML(productId) {
    /* Step guide — reuses existing .tbw-bk-step classes.
       Bouquet sheets (window.tbwSheetIsBq) swap COD steps for prepaid ones. */
    var isBqGuide = !!window.tbwSheetIsBq;
    var steps = [
      { n:'1', title:'Pick Your Design',   desc:'Choose any decoration — you can change colours, add names, characters or any element even after ordering.' },
      { n:'2', title:'Enter Your Details', desc:'Add your pincode, event date and a 2-hour setup slot.' },
      (isBqGuide
        ? { n:'3', title:'Add to Cart & Checkout', desc:'Tap Add to Cart and pay securely online — balloon bouquets are prepaid only.' }
        : { n:'3', title:'Add to Cart & Checkout', desc:'Tap Add to Cart, head to cart and checkout. Prepaid or Cash on Delivery — your choice.' }),
      { n:'4', title:'We Connect on WhatsApp', desc:'Our team messages you on WhatsApp right after the order. Discuss customisation, addons, anything.' },
      { n:'5', title:'Decorator Arrives', desc:'A professional decorator comes to your address with all materials. Usually 1 person, ~45 min to 1 hr.' },
      (isBqGuide
        ? { n:'6', title:'Prepaid & Scheduled', desc:'Your order is confirmed the moment payment completes — the decorator arrives in your chosen slot.' }
        : { n:'6', title:'Enjoy, Then Pay',   desc:'Love the setup? Pay Cash on Delivery. You are completely safe — no advance, no risk.' }),
    ];

    /* FAQ array — Rishi will supply final Q&A copy here */
    var faqs = [
      { q:'Do you do the decor or just supply materials?', a:'We do everything — our team comes to your place with all materials and sets up the full decoration. You just place the order and relax.' },
      { q:'What if I want to make changes after ordering?', a:'No problem at all. Place the order and our team connects with you on WhatsApp right after. Tell them exactly what you want changed.' },
      { q:'Are there any extra charges apart from the listed price?', a:'No. The price shown is final. Price only changes if you choose to add something extra to the decor.' },
      { q:'How do I reach you for queries?', a:'We are on WhatsApp 24x7. Message us anytime for anything related to your order.' },
      { q:'What happens after I place the order?', a:'Our team immediately connects with you on WhatsApp and guides you through everything — customisation, timing, address confirmation.' },
      { q:'When will I get the decorator details?', a:'Our decorator calls you on the day of the event. Until then, stay in touch with our team on WhatsApp for any updates.' },
      { q:'Do you take same-day orders?', a:'Yes! Same-day setup is available in most cities — prepaid only, with ₹200 express charges. Slots close as the day progresses, so book as early as possible for the widest choice.' },
      { q:'How do I cancel or reschedule?', a:'Just message us on WhatsApp from the number used to place the order — cancellations and date changes, both are handled there.' },
      { q:'How many decorators come and how long does it take?', a:'Usually 1 professional decorator. The setup typically takes 45 minutes to 1 hour depending on the size of the decor.' },
    ];

    var stepsHTML = steps.map(function(s) {
      return '<div class="tbw-bk-step"><div class="tbw-bk-n">' + s.n + '</div><div><div class="tbw-bk-tt">' + s.title + '</div><div class="tbw-bk-ds">' + s.desc + '</div></div></div>';
    }).join('');

    var faqsHTML = faqs.map(function(f, i) {
      return '<div class="tbw-guide-faq-item" id="tbw-faq-' + i + '">'
        + '<div class="tbw-guide-faq-q" onclick="tbwToggleFaq(' + i + ')">'
        + f.q
        + '<span class="tbw-guide-faq-ic">▼</span>'
        + '</div>'
        + '<div class="tbw-guide-faq-a">' + f.a + '</div>'
        + '</div>';
    }).join('');

    return ''
      + stepsHTML
      + '<div class="tbw-guide-faq">'
      + '<div style="font-size:13px;font-weight:700;color:var(--ink);margin-bottom:12px">Frequently Asked Questions</div>'
      + faqsHTML
      + '</div>'
      + '<div class="tbw-guide-wa">'
      + '<h4>💬 Still have a question?</h4>'
      + '<p>Enter your pincode and we will open WhatsApp — our team replies in minutes.</p>'
      + '<div class="tbw-guide-wa-pin">'
      + '<input id="tbw-guide-pin" type="tel" maxlength="6" placeholder="Your pincode…" />'
      + '<button onclick="tbwGuideWaConfirm(\'' + esc(productId) + '\')">Chat on WhatsApp</button>'
      + '</div>'
      + '</div>';
  }

  function openGuide(productId) {
    var guide = document.getElementById('tbw-guide');
    var body  = document.getElementById('tbw-guide-body');
    var ov    = document.getElementById('tbw-guide-ov');
    if (!guide || !body) return;
    /* Write content into the body div only — never replace the container,
       or we destroy #tbw-guide-ov and #tbw-guide-pan which drive open/close. */
    body.innerHTML = bookingGuideHTML(productId);
    /* Overlay: detach stale listeners by cloning the node, then re-attach */
    if (ov) {
      var ov2 = ov.cloneNode(false);
      ov.parentNode.replaceChild(ov2, ov);
      ov2.addEventListener('touchend', function(e){ e.preventDefault(); closeGuide(); });
      ov2.addEventListener('click', function(){ closeGuide(); });
    }
    guide.classList.add('open');
    body.scrollTop = 0;
    if (window.location.hash !== '#tbw-guide-open') { window.location.hash = 'tbw-guide-open'; }
  }

  window.tbwOpenBookingGuide = openGuide;
  window.tbwCloseGuide       = closeGuide;

  window.tbwToggleFaq = function(i) {
    var el = document.getElementById('tbw-faq-' + i);
    if (el) el.classList.toggle('open');
  };

  window.tbwGuideWaConfirm = function(productId) {
    var pin = (document.getElementById('tbw-guide-pin') || {}).value || '';
    var msg = 'Hi! I want to book this decoration.' + (pin ? ' My pincode is ' + pin + '.' : '') + ' Please confirm availability.';
    var WA_NUM = '919876543210';
    /* Try to get WA number from existing waOpen closure scope via tbwWaOpen fallback */
    try { window.tbwWaOpen(msg); return; } catch(e){}
    window.open('https://wa.me/' + WA_NUM + '?text=' + encodeURIComponent(msg), '_blank');
  };





  /* Scroll the swipe gallery to a given slide index (called by thumbnail tap). */


  function scrollGal(idx) {


    var gal = document.getElementById('tbw-ps-gal');


    if (!gal) return;


    gal.scrollTo({ left: idx * gal.clientWidth, behavior: 'smooth' });


  }


  window.tbwScrollGal = scrollGal;


  /* Fires when a user taps a row in the "Choose No. of Balloons" (or any
     future multi-variant) selector inside the product sheet. Updates the
     visible price and remembers the chosen variant id so Add to Cart picks
     it up (see the button's onclick in renderSheet). */
  function selectVariant(el, vid, price) {
    var list = document.getElementById('tbw-vp-list');
    if (list) list.querySelectorAll('.tbw-vp-opt').forEach(function (o) { o.classList.remove('on'); });
    if (el) el.classList.add('on');
    window.tbwSelectedVariantId = vid;
    var priceEl = document.getElementById('tbw-ps-price');
    if (priceEl) priceEl.textContent = fmt(price);
  }
  window.tbwSelectVariant = selectVariant;





  /* Sync thumbnail highlight as the user swipes through the gallery. */


  function addGalleryScrollSync() {


    var gal = document.getElementById('tbw-ps-gal');


    if (!gal) return;


    gal.addEventListener('scroll', function () {


      var idx = Math.round(gal.scrollLeft / (gal.clientWidth || 1));


      var thumbs = document.querySelectorAll('.tbw-ps-thumb');


      for (var i = 0; i < thumbs.length; i++) {


        thumbs[i].classList.toggle('on', i === idx);


      }


    }, { passive: true });


  }





  /* Legacy single-image swap — kept for any inline references. */


  function swapImg(el, full) {


    var img = document.getElementById('tbw-ps-img');


    if (img) { img.style.display = ''; img.src = full; }


    var thumbs = document.querySelectorAll('.tbw-ps-thumb');


    for (var i = 0; i < thumbs.length; i++) thumbs[i].classList.remove('on');


    el.classList.add('on');


  }


  window.tbwSwapImg = swapImg;





  /* Early morning (before 11 AM) or late night (after 10 PM) → show green notice. */


  function timeNotice(val) {


    var note = document.getElementById('tbw-time-note');


    if (!note) return;


    var show = false;


    if (val) {


      var parts = val.split(':');


      var mins  = parseInt(parts[0], 10) * 60 + parseInt(parts[1] || '0', 10);


      show = mins < 11 * 60 || mins > 22 * 60;


    }


    note.style.display = show ? 'block' : 'none';


  }


  window.tbwTimeNotice = timeNotice;

  /* Slot picker — writes the chosen slot into hidden #tbw-sh-time so validation,
     cart add, WhatsApp and read-backs keep working unchanged. */
  window.tbwPickSlot = function (btn) {
    if (btn.disabled) return;
    var h = document.getElementById('tbw-sh-time');
    if (h) h.value = btn.getAttribute('data-v');
    var wrap = btn.parentNode;
    var bs = wrap ? wrap.querySelectorAll('.tbw-slot') : [];
    for (var i = 0; i < bs.length; i++) bs[i].classList.remove('sel');
    btn.classList.add('sel');
    var c = document.getElementById('tbw-sh-slots');
    if (c) c.style.borderColor = 'transparent';
    var dn = document.getElementById('tbw-delay-note');
    var d  = (document.getElementById('tbw-sh-date') || {}).value || '';
    if (dn) dn.style.display = (btn.classList.contains('tbw-slot-warn') && tbwIsToday(d)) ? 'block' : 'none';
  };

  /* ── Same-day express ──────────────────────────────────────────────
     Flat fee, max 1 per order. Gating rule for today: the slot the customer
     is booking in (and every earlier one) plus the NEXT slot are blocked;
     the slot after that carries a 'slight delay' warning; later slots clean. */
  var TBW_FEE_VID = 52940910887224;
  /* ── Bengaluru far-pincode conveyance (2026-10) — flat ₹300, max 1 per order.
        Pincodes 560099, 560100, 560101–560120, 562125; only when the sheet city
        is Bangalore. Notice shows live while the pincode is typed. ── */
  var TBW_CONV_VID = 53409280295224;
  var TBW_CONV_PINS = new Set(['560099', '560100', '562125']);
  for (var _cp = 560101; _cp <= 560120; _cp++) TBW_CONV_PINS.add(String(_cp));
  function tbwConvApplies(city, pin) {
    return /bengaluru|bangalore/i.test(String(city || '')) && TBW_CONV_PINS.has(String(pin || '').trim());
  }
  window.tbwPinCheck = function () {
    try {
      var pin = (document.getElementById('tbw-sh-pin') || {}).value || '';
      var n  = document.getElementById('tbw-conv-note');
      if (n) n.style.display = tbwConvApplies(currentCity, pin) ? 'block' : 'none';
    } catch (e) {}
  };
  window.tbwAddonNote = function () {
    var n = document.getElementById('tbw-addon-note');
    if (n) n.style.display = document.querySelectorAll('.tbw-chip.on').length ? 'block' : 'none';
  };
  var TBW_SLOTS_DEF = [
    { v: '10 AM – 12 PM', start: 600,  end: 720  },
    { v: '12 PM – 2 PM',  start: 720,  end: 840  },
    { v: '2 PM – 4 PM',   start: 840,  end: 960  },
    { v: '4 PM – 6 PM',   start: 960,  end: 1080 },
    { v: '6 PM – 8 PM',   start: 1080, end: 1200 },
    { v: '8 PM – 10 PM',  start: 1200, end: 1320 }
  ];
  function tbwIsToday(val) {
    var t = new Date();
    return val === (t.getFullYear() + '-' + String(t.getMonth() + 1).padStart(2, '0') + '-' + String(t.getDate()).padStart(2, '0'));
  }
  function tbwIsTomorrow(val) {
    var t = new Date(); t.setDate(t.getDate() + 1);
    return val === (t.getFullYear() + '-' + String(t.getMonth() + 1).padStart(2, '0') + '-' + String(t.getDate()).padStart(2, '0'));
  }
  /* Next-day morning rule: booked from 11 PM (1380) onward, tomorrow's first slot is off. */
  function tbwEveningNow() {
    var n = new Date();
    return n.getHours() * 60 + n.getMinutes() >= 1380;
  }
  function tbwTodaySlotState() {
    var n = new Date(), mins = n.getHours() * 60 + n.getMinutes(), k = 0;
    if (mins >= 1320) return { over: true, cut: 6, warn: -1 };
    for (var i = 0; i < TBW_SLOTS_DEF.length; i++) {
      if (mins >= TBW_SLOTS_DEF[i].start && mins < TBW_SLOTS_DEF[i].end) { k = i + 1; break; }
    }
    return { over: false, cut: k + 1, warn: k + 2 };
  }


  /* Same-day express: gate today's slots by the current time. */
  function dateNotice(val) {
    var wrap = document.getElementById('tbw-sh-slots');
    var note = document.getElementById('tbw-sameday-note');
    var dn   = document.getElementById('tbw-delay-note');
    var h    = document.getElementById('tbw-sh-time');
    if (dn) dn.style.display = 'none';
    if (!wrap || !note) return;
    var st = tbwTodaySlotState();
    var isToday = !!(val && tbwIsToday(val));
    var firstOff = !!(val && tbwIsTomorrow(val) && tbwEveningNow());
    var btns = wrap.querySelectorAll('.tbw-slot');
    for (var i = 0; i < btns.length; i++) {
      var n = i + 1, b = btns[i], dis = (isToday && (st.over || n <= st.cut)) || (firstOff && n === 1);
      b.disabled = dis;
      b.classList.toggle('tbw-slot-off', dis);
      b.classList.toggle('tbw-slot-warn', !!( !st.over && isToday && n === st.warn ));
      if (dis && b.classList.contains('sel')) { b.classList.remove('sel'); if (h) h.value = ''; }
    }
    if (!isToday) {
      if (firstOff) {
        note.style.display = 'block';
        note.innerHTML = '\ud83c\udf19 <strong>Heads up:</strong> tomorrow\u2019s 10 AM\u201312 PM slot closes at 11 PM tonight \u2014 please pick a later slot.';
      } else { note.style.display = 'none'; }
      return;
    }
    note.style.display = 'block';
    note.innerHTML = st.over
      ? '🌇 <strong>Today\'s same-day slots are over.</strong> Please pick a date from tomorrow onwards.'
      : '⚡ <strong>Same-day express:</strong> prepaid only · ₹200 express decor charges added at cart.';
  }

  window.tbwDateNotice = dateNotice;





  /* Require pincode + date + time before Add to Cart / Customise / Book on WhatsApp. */


  function validateSheet() {


    var pin  = (document.getElementById('tbw-sh-pin')  || {}).value || '';


    var date = (document.getElementById('tbw-sh-date') || {}).value || '';


    var time = (document.getElementById('tbw-sh-time') || {}).value || '';


    var missing = [];


    if (!date)                    missing.push('event date');


    if (!pin || pin.length < 6)   missing.push('pincode');


    if (!time)                    missing.push('setup slot');


    if (missing.length) {


      showToast('Please fill ' + missing.join(', ') + ' first');


      /* Focus pincode first, then date, then time */
      var firstId = (!pin || pin.length < 6) ? 'tbw-sh-pin' : (!date ? 'tbw-sh-date' : 'tbw-sh-slots');


      var el = document.getElementById(firstId);


      if (el) { try { el.focus(); } catch (e) {} el.style.borderColor = 'var(--coral)'; }


      return false;


    }


    /* Next-day morning rule: tomorrow's first slot is gone once it is 11 PM. */
    if (tbwIsTomorrow(date) && tbwEveningNow() && time === TBW_SLOTS_DEF[0].v) {
      showToast('The 10 AM\u201312 PM slot for tomorrow must be booked before 11 PM tonight. Please pick a later slot.');
      dateNotice(date);
      return false;
    }

    /* Same-day express: the chosen slot must still be available for today. */
    if (tbwIsToday(date)) {
      var st = tbwTodaySlotState();
      var idx = 0;
      for (var si = 0; si < TBW_SLOTS_DEF.length; si++) if (TBW_SLOTS_DEF[si].v === time) { idx = si + 1; break; }
      if (st.over || (idx && idx <= st.cut)) {
        showToast('That slot is not available for today. Please pick a later slot or tomorrow\'s date.');
        dateNotice(date);
        return false;
      }
    }


    return true;


  }





  /* ================================================================


     WHATSAPP


  ================================================================ */


  function waIconSVG() {


    return '<svg width="16" height="16" viewBox="0 0 24 24" fill="white" aria-hidden="true"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z"/><path d="M12 0C5.373 0 0 5.373 0 12c0 2.124.558 4.118 1.528 5.845L0 24l6.335-1.528A11.946 11.946 0 0 0 12 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 21.818a9.818 9.818 0 0 1-5.006-1.374l-.358-.214-3.758.908.924-3.664-.234-.376A9.82 9.82 0 0 1 2.182 12C2.182 6.58 6.58 2.182 12 2.182c5.42 0 9.818 4.398 9.818 9.818 0 5.42-4.398 9.818-9.818 9.818z"/></svg>';


  }





  function buildMsg(id) {


    var keys   = Object.keys(cache);


    var p      = null;


    for (var i = 0; i < keys.length; i++) {


      p = cache[keys[i]].find(function(x){ return x.id === id; });


      if (p) break;


    }


    var title  = p ? p.title : 'decoration';


    var pin    = (document.getElementById('tbw-sh-pin')  || {}).value || '';


    var date   = (document.getElementById('tbw-sh-date') || {}).value || '';


    var time   = (document.getElementById('tbw-sh-time') || {}).value || '';


    var msg    = (document.getElementById('tbw-sh-msg')  || {}).value || '';


    var chips  = Array.from(document.querySelectorAll('.tbw-chip.on')).map(function(c){ var s = c.querySelector('span'); return (s ? s.textContent : c.textContent).trim(); }).join(', ');


    var wa     = "Hi! I'd like to book: " + title + "\n";


    if (p && p.handle) wa += '🔗 ' + window.location.origin + '/products/' + p.handle + '\n';


    if (p && p.imgFull) wa += '🖼️ ' + p.imgFull + '\n';


    wa += '📍 City: ' + currentCity + '\n';


    if (pin)   wa += '📌 Pincode: ' + pin + '\n';


    if (date)  wa += '📅 Date: ' + date + '\n';

    if (date && tbwIsToday(date)) wa += '⚡ Same-day express: +₹200 (prepaid only)\n';


    if (time)  wa += '⏰ Completed by: ' + time + '\n';


    if (chips) wa += '✏️ Changes: ' + chips + '\n';


    if (msg)   wa += '📝 Notes: ' + msg + '\n';


    wa += '\nPlease confirm availability and final price. Thank you!';


    return wa;


  }





  function waOpen(msg) {


    if (window.dataLayer) window.dataLayer.push({ event: 'whatsapp_lead' });


    window.open('https://wa.me/' + WA + '?text=' + encodeURIComponent(msg), '_blank');


  }


  window.tbwWaOpen     = waOpen;


  window.tbwBookWA     = function(id){ if (!validateSheet()) return; waOpen(buildMsg(id)); };


  window.tbwSendCustWA = function(id){ if (!validateSheet()) return; waOpen(buildMsg(id)); };


  window.tbwQuickWA = function(title, handle) {


    var m = "Hi! I'm from " + currentCity + " and want to enquire about this decoration — " + title + "\n";


    if (handle) m += '🔗 ' + window.location.origin + '/products/' + handle + '\n';


    m += '\nCould you share details and pricing? Thank you.';


    waOpen(m);


  };





  /* ================================================================


     CART


  ================================================================ */


  var cart = [];





  /* ── SHOPIFY CART SYNC ──


     The cart tab is rendered from this in-memory `cart` array. Shopify is the


     single source of truth: we map its cart into our shape and re-apply it


     after every add/change/remove, and on page load. This keeps the app cart,


     the Shopify cart and the checkout in lock-step.





     Note: each line carries its Shopify line-item `key`. Quantity/remove calls


     target that key (not the variant id) so the exact line is changed — two


     different products, or the same variant with different properties, can no


     longer be confused. */


  function mapCartItems(data) {


    var items = (data && data.items) || [];


    return items.map(function (it) {


      var props = it.properties || {};


      return {


        id:     String(it.product_id),


        vid:    String(it.variant_id || it.id),


        key:    it.key,                            /* unique per line item */


        title:  it.product_title || it.title || '',


        variantTitle: it.variant_title || '',


        price:  it.price,                          /* paise — matches fmt() */


        img:    it.image ? addW(it.image, 210) : '',


        handle: it.handle || '',


        qty:    it.quantity || 1,


        pin:    props['Pincode'] || '',


        date:   props['Event Date']  || props['Completion Date'] || '',


        time:   props['Completed By'] || props['Completion Time'] || '',


        chips:  props['Customisation'] || '',


        note:   props['Order Notes'] || ''


      };


    });


  }





  /* Replace local cart with the authoritative server cart and refresh UI. */


  function applyCart(data) {


    cart = mapCartItems(data);


    updateBadge(cart.reduce(function (s, c) { return s + c.qty; }, 0));


    var cartScr = document.getElementById('tbw-s-cart');


    if (cartScr && cartScr.classList.contains('on')) renderCart();


  }





  function hydrateCart() {


    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })


      .then(function (r) { return r.json(); })


      .then(applyCart)


      .catch(function () {});


  }





  function tbwAddToCart(id, vid) {


    if (!validateSheet()) return;


    var p = null;


    var keys = Object.keys(cache);


    for (var i = 0; i < keys.length; i++) {


      p = cache[keys[i]].find(function(x){ return x.id === id; });


      if (p) break;


    }


    if (!p) return;


    /* Resolve the variant actually being added — may differ from p.vid if
       the shopper picked a non-default row in the sheet's variant selector. */
    var chosenVid      = String(vid || p.vid);
    var chosenVariant  = (p.variants || []).find(function (v) { return v.id === chosenVid; });
    var chosenPrice    = chosenVariant ? chosenVariant.price : p.price;
    var chosenTitle    = chosenVariant ? (chosenVariant.option1 || chosenVariant.title || '') : '';



    var pin   = (document.getElementById('tbw-sh-pin')  || {}).value || '';


    var date  = (document.getElementById('tbw-sh-date') || {}).value || '';


    var time  = (document.getElementById('tbw-sh-time') || {}).value || '';


    var msg   = (document.getElementById('tbw-sh-msg')  || {}).value || '';


    var chips = Array.from(document.querySelectorAll('.tbw-chip.on')).map(function(c){ var s = c.querySelector('span'); return (s ? s.textContent : c.textContent).trim(); }).join(', ');





    /* Local state — keyed by product id + variant id so two different
       variants of the same product become two separate cart lines. */


    var existing = cart.find(function(c){ return c.id === id && c.vid === chosenVid; });


    if (existing) { existing.qty++; }


    else          { cart.push(Object.assign({}, p, { qty: 1, pin: pin, date: date, time: time, chips: chips, note: msg, vid: chosenVid, price: chosenPrice, variantTitle: chosenTitle })); }


    updateBadge(cart.reduce(function(s,c){ return s + c.qty; }, 0));





    /* Swipe the sheet down, blink the cart icon, show a short toast */


    closePS();


    blinkCart();


    showToast('Added to cart 🛒');





    /* Shopify Cart API — these become line item properties visible on checkout */


    var body = { id: parseInt(chosenVid), quantity: 1, properties: {} };


    if (currentCity) body.properties['City']           = currentCity;


    if (pin)         body.properties['Pincode']        = pin;


    if (date)        body.properties['Event Date']     = date;


    if (time)        body.properties['Completed By']   = time;


    if (chips)       body.properties['Customisation']  = chips;


    if (msg)         body.properties['Order Notes']    = msg;

    /* Same-day express: flat ₹200 fee, max once per order. */
    var tbwSameDay = tbwIsToday(date);
    if (tbwSameDay) {
      body.properties['Same Day'] = 'Yes — prepaid only';
      var tbwHasFee = cart.some(function(c){ return String(c.vid) === String(TBW_FEE_VID); });
      if (!tbwHasFee) body = { items: [ body, { id: TBW_FEE_VID, quantity: 1, properties: { 'Express Fee': 'Same-day setup', 'Type': 'Auto-added' } } ] };
    }
    /* Bengaluru far-pincode conveyance: flat ₹300, max once per order. */
    if (tbwConvApplies(currentCity, pin)) {
      var tbwHasConv = cart.some(function(c){ return String(c.vid) === String(TBW_CONV_VID); });
      if (!tbwHasConv) {
        var tbwConvItem = { id: TBW_CONV_VID, quantity: 1, properties: { 'Conveyance': 'Far pincode ' + String(pin).trim(), 'Type': 'Auto-added' } };
        body = (body && body.items) ? { items: body.items.concat([tbwConvItem]) } : { items: [ body, tbwConvItem ] };
      }
    }





    fetch('/cart/add.js', {


      method: 'POST',


      headers: { 'Content-Type': 'application/json' },


      body: JSON.stringify(body)


    })


    .then(function(r){ return r.json(); })


    .then(function(){


      if (window.dataLayer) window.dataLayer.push({ event: 'add_to_cart', ecommerce: { items: [{ item_id: p.id, item_name: p.title, price: chosenPrice / 100 }] } });


      fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { 'Same Day': tbwSameDay ? 'Yes — prepaid only (₹200 express)' : 'No' } }) }).catch(function(){});

      /* Re-sync from the server so line keys + merged quantities are accurate. */


      hydrateCart().then(checkBookingReturn);


    })


    .catch(function(){});


  }


  window.tbwAddToCart = tbwAddToCart;





  /* ── RENDER CART ── */


  function renderCart() {


    var w = document.getElementById('tbw-cart-body');


    if (!w) return;





    if (!cart.length) {


      w.innerHTML = '<div style="text-align:center;padding:60px 18px">'


        + '<div style="font-size:48px;margin-bottom:14px">🛒</div>'


        + '<div style="font-size:15px;font-weight:600;color:var(--ink);margin-bottom:6px">Your cart is empty</div>'


        + '<div style="font-size:13px;color:var(--muted);margin-bottom:20px;font-weight:300">Browse our setups and add what you like</div>'


        + '<button onclick="tbwGoTab(\'explore\')" style="background:var(--coral);color:#fff;border:none;border-radius:10px;padding:13px 24px;font-size:14px;font-weight:600;cursor:pointer">Browse Setups</button>'


        + '</div>';


      return;


    }





    var total = cart.reduce(function(s,c){ return s + (c.price * c.qty); }, 0);





    var items = cart.map(function(item){


      return '<div style="background:var(--card);border:1px solid var(--border);border-radius:var(--r);margin-bottom:10px;display:grid;grid-template-columns:80px 1fr;overflow:hidden;box-shadow:var(--sh)">'


        + (item.img ? '<img src="' + esc(item.img) + '" style="width:80px;height:80px;object-fit:cover;display:block" alt="' + esc(item.title) + '"/>' : '<div style="width:80px;height:80px;background:var(--bg2)"></div>')


        + '<div style="padding:11px 13px">'


        + '<div style="font-size:12.5px;font-weight:600;color:var(--ink);margin-bottom:3px;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden">' + esc(item.title) + '</div>'


        + (item.variantTitle ? '<div style="font-size:11px;color:var(--coral-d);font-weight:600;margin-bottom:2px">🎈 ' + esc(item.variantTitle) + '</div>' : '')


        + (item.date  ? '<div style="font-size:11px;color:var(--muted);margin-bottom:2px">📅 ' + esc(item.date)  + '</div>' : '')


        + (item.time  ? '<div style="font-size:11px;color:var(--muted);margin-bottom:2px">⏰ ' + esc(item.time)  + '</div>' : '')


        + (item.chips ? '<div style="font-size:11px;color:var(--muted);margin-bottom:2px">✏️ ' + esc(item.chips) + '</div>' : '')


        + '<div style="font-size:13.5px;font-weight:700;color:var(--coral);margin-bottom:8px">' + fmt(item.price) + '</div>'


        + '<div style="display:flex;align-items:center;gap:10px">'


        + '<div style="display:flex;align-items:center;gap:8px;background:var(--bg2);border-radius:6px;padding:4px 8px">'


        + '<button onclick="tbwQtyChange(\'' + item.id + '\',\'' + item.vid + '\',-1)" style="background:none;border:none;font-size:16px;cursor:pointer;color:var(--muted);padding:0;line-height:1">−</button>'


        + '<span style="font-size:13px;font-weight:600;min-width:16px;text-align:center">' + item.qty + '</span>'


        + '<button onclick="tbwQtyChange(\'' + item.id + '\',\'' + item.vid + '\',1)" style="background:none;border:none;font-size:16px;cursor:pointer;color:var(--muted);padding:0;line-height:1">+</button>'


        + '</div>'


        + '<button onclick="tbwRemoveItem(\'' + item.id + '\',\'' + item.vid + '\')" style="background:none;border:none;font-size:12px;color:var(--muted);cursor:pointer">Remove</button>'


        + '</div></div></div>';


    }).join('');





    var infoBlock = '<div style="background:var(--gl);border:1px solid var(--gb);border-radius:var(--r);padding:14px 15px;margin-bottom:14px">'


      + '<div style="font-size:12.5px;font-weight:700;color:var(--green);margin-bottom:6px">ℹ️ Choose your payment at checkout</div>'


      + '<div style="font-size:12px;color:var(--ink2);font-weight:300;line-height:1.65">'


      + 'On the next step you can select <strong>Cash on Delivery</strong> or <strong>Prepaid</strong>.'


      + '</div></div>';





    w.innerHTML = items


      + '<div style="background:var(--card);border:1px solid var(--border);border-radius:var(--r);padding:16px;margin-bottom:14px;box-shadow:var(--sh);display:flex;justify-content:space-between;align-items:center">'


      + '<span style="font-size:13px;color:var(--muted);font-weight:300">Subtotal</span>'


      + '<span style="font-size:16px;font-weight:700;color:var(--ink)">' + fmt(total) + '</span>'


      + '</div>'


      + infoBlock


      + '<button onclick="tbwPlaceOrder()" style="width:100%;background:var(--coral);color:#fff;border:none;border-radius:10px;padding:15px;font-size:15px;font-weight:700;cursor:pointer;display:flex;align-items:center;justify-content:center;gap:8px;margin-bottom:24px;font-family:var(--F)">🛍️ Proceed to Checkout →</button>';


  }


  window.tbwRenderCart = renderCart;





  function tbwQtyChange(id, vid, delta) {


    var item = cart.find(function(c){ return c.id === id && c.vid === vid; });


    if (!item) return;


    var newQty = Math.max(0, item.qty + delta);


    /* Optimistic update for snappy UI… */


    item.qty = newQty;


    if (item.qty <= 0) cart = cart.filter(function(c){ return !(c.id === id && c.vid === vid); });


    updateBadge(cart.reduce(function(s,c){ return s + c.qty; }, 0));


    renderCart();


    /* …then change the exact line by key and reconcile with the server. */


    fetch('/cart/change.js', { method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},


      body: JSON.stringify({ id: item.key || String(item.vid), quantity: newQty }) })


      .then(function(r){ return r.json(); })


      .then(applyCart)


      .catch(function(){});


  }


  window.tbwQtyChange = tbwQtyChange;





  function tbwRemoveItem(id, vid) {


    var item = cart.find(function(c){ return c.id === id && c.vid === vid; });


    if (!item) return;


    /* Optimistic removal… */


    cart = cart.filter(function(c){ return !(c.id === id && c.vid === vid); });


    updateBadge(cart.reduce(function(s,c){ return s + c.qty; }, 0));


    renderCart();


    showToast('Removed from cart');


    /* …then remove the exact line by key and reconcile with the server so the


       checkout reflects the real cart (fixes removed item reappearing). */


    fetch('/cart/change.js', { method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},


      body: JSON.stringify({ id: item.key || String(item.vid), quantity: 0 }) })


      .then(function(r){ return r.json(); })


      .then(applyCart)


      .catch(function(){});


  }


  window.tbwRemoveItem = tbwRemoveItem;





    function tbwPlaceOrder() {


    if (!cart.length) { showToast('Your cart is empty'); return; }


    /* Same-day fee guard (2026-09-12): the ₹200 express fee is mandatory
       for today's orders — if the fee line was removed, re-add it before
       checkout instead of redirecting without it. */
    var _needFee = false, _hasFee = false;
    for (var _i = 0; _i < cart.length; _i++) {
      if (String(cart[_i].vid) === String(TBW_FEE_VID)) { _hasFee = true; continue; }
      if (cart[_i].date && tbwIsToday(cart[_i].date)) _needFee = true;
    }
    if (_needFee && !_hasFee) {
      showToast('⚡ Express fee (₹200) is mandatory for same-day orders — adding it…');
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: TBW_FEE_VID, quantity: 1, properties: { 'Express Fee': 'Same-day setup', 'Type': 'Auto-added' } }] }) })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return hydrateCart(); })
        .then(function () { tbwGoCheckout(); })
        .catch(function () { showToast('Could not add the ₹200 express fee — please try again'); });
      return;
    }
    tbwGoCheckout();


  }


  function tbwGoCheckout() {


    savePendingOrder();


    showToast('Redirecting to checkout…');


    if (window.dataLayer) window.dataLayer.push({ event: 'purchase_intent' });


    window.location.href = '/checkout';


  }


  window.tbwPlaceOrder = tbwPlaceOrder;





  /* ================================================================


     CITY SELECTOR


  ================================================================ */


  function openCity() { document.getElementById('tbw-cs').classList.add('open'); }


  function closeCity() {
    if (cityGateForced) return; /* mandatory gate: only setCity() may close it */
    document.getElementById('tbw-cs').classList.remove('open');
  }


  /* Mandatory first-visit gate — no saved city yet. Blurs + freezes the shell
     (same treatment as the product sheet) and disables the usual tap-outside/
     handle dismissal until the visitor actually picks a city. */
  function forceOpenCity() {
    cityGateForced = true;
    document.querySelectorAll('.tbw-cs-opt').forEach(function(c){ c.classList.remove('on'); });
    var cs = document.getElementById('tbw-cs');
    if (cs) { cs.classList.add('open'); cs.classList.add('forced'); }
    var shell = document.getElementById('tbw-shell');
    if (shell) { shell.style.filter = 'blur(8px)'; shell.style.pointerEvents = 'none'; }
    document.body.style.overflow = 'hidden';
    var title = document.getElementById('tbw-cs-title');
    if (title) title.textContent = '👋 Welcome! Select Your City';
    var sub = document.getElementById('tbw-cs-sub');
    if (sub) { sub.textContent = "We're live in 15 cities — pick yours to see accurate local pricing & availability"; sub.style.display = 'block'; }
  }


  /* ================================================================
     CHENNAI PINCODE SERVICEABILITY (2026-10) - informational gateway.
     Opens when the visitor selects Chennai. Match = we service the
     pincode; mismatch = politely told we are not there yet but free to
     explore. Never blocks browsing. Last check persists in
     localStorage.tbw_pin_chennai (shared key with desktop).
  ================================================================ */
  const TBW_CHENNAI_PINS = new Set(["600001","600002","600003","600004","600005","600006","600007","600008","600009","600010","600011","600012","600014","600016","600017","600018","600020","600021","600023","600024","600026","600028","600031","600032","600033","600034","600039","600040","600041","600042","600043","600061","600078","600079","600083","600086","600087","600088","600090","600094","600095","600097","600101","600102","600106","600108","600112"]);

  function tbwPinLast() {
    try { return JSON.parse(localStorage.getItem('tbw_pin_chennai') || 'null'); } catch (e) { return null; }
  }

  function openPinCheck() {
    var old = document.getElementById('tbw-pincheck'); if (old) old.remove();
    var ov = document.createElement('div');
    ov.id = 'tbw-pincheck';
    ov.style.cssText = 'position:fixed;inset:0;z-index:99999;background:rgba(20,10,10,.55);display:flex;align-items:center;justify-content:center;padding:20px;';
    var box = document.createElement('div');
    box.style.cssText = 'background:#fff;border-radius:18px;max-width:340px;width:100%;padding:22px 18px;text-align:center;box-shadow:0 18px 50px rgba(0,0,0,.25);';
    var last = tbwPinLast();
    box.innerHTML =
      '<div style="font-size:30px;margin-bottom:6px">\uD83D\uDCCD</div>' +
      '<div style="font-size:17px;font-weight:700;margin-bottom:4px">Check service in Chennai</div>' +
      '<div style="font-size:13px;color:#777;margin-bottom:14px">Enter your pincode to check decoration service availability</div>' +
      '<input id="tbw-pin-in" type="text" inputmode="numeric" maxlength="6" placeholder="e.g. 600001" style="width:100%;box-sizing:border-box;border:1.5px solid #e5c9c4;border-radius:10px;padding:11px 12px;font-size:16px;text-align:center;letter-spacing:2px;outline:none;" />' +
      '<div id="tbw-pin-msg" style="min-height:18px;margin:10px 0 4px;font-size:13px;line-height:1.45">' +
      (last ? (last.ok ? '\u2705 Last check: ' + last.pin + ' - serviceable' : 'Last check: ' + last.pin + ' - not serviceable yet') : '') +
      '</div>' +
      '<button id="tbw-pin-go" style="width:100%;margin-top:6px;background:#e84830;color:#fff;border:0;border-radius:10px;padding:12px;font-size:15px;font-weight:700;">Check serviceability</button>' +
      '<div id="tbw-pin-close" role="button" style="margin-top:12px;font-size:13px;color:#999;text-decoration:underline;">Skip - I will just explore \uD83C\uDF88</div>';
    ov.appendChild(box);
    document.body.appendChild(ov);
    ov.addEventListener('click', function (e) { if (e.target === ov) ov.remove(); });
    document.getElementById('tbw-pin-close').addEventListener('click', function () { ov.remove(); });
    var run = function () {
      var v = (document.getElementById('tbw-pin-in').value || '').replace(/\D/g, '');
      var msg = document.getElementById('tbw-pin-msg');
      if (v.length !== 6) { msg.style.color = '#c0392b'; msg.textContent = 'Please enter a valid 6-digit pincode'; return; }
      var ok = TBW_CHENNAI_PINS.has(v);
      try { localStorage.setItem('tbw_pin_chennai', JSON.stringify({ pin: v, ok: ok, at: Date.now() })); } catch (e) {}
      if (ok) {
        msg.style.color = '#1e8e3e';
        msg.innerHTML = '\u2705 Great news! We service <b>' + v + '</b>.<br>Same-day & scheduled setups available in Chennai.';
        document.getElementById('tbw-pin-close').textContent = 'Explore Chennai designs \u2192';
      } else {
        msg.style.color = '#b3541e';
        msg.innerHTML = '\uD83D\uDE14 We are currently unavailable at <b>' + v + '</b>.<br>But you can still explore the website & book anywhere we serve \uD83C\uDF88';
      }
    };
    document.getElementById('tbw-pin-go').addEventListener('click', run);
    document.getElementById('tbw-pin-in').addEventListener('keydown', function (e) { if (e.key === 'Enter') run(); });
    setTimeout(function () { try { document.getElementById('tbw-pin-in').focus(); } catch (e) {} }, 80);
  }

  window.tbwOpenPinCheck = openPinCheck;

  function setCity(el, name) {


    document.querySelectorAll('.tbw-cs-opt').forEach(function(c){ c.classList.remove('on'); });


    el.classList.add('on');


    currentCity = name;
    tbwBqNavSync();


    ['tbw-sel-city','tbw-hero-city','tbw-pm-city','tbw-csp-city','tbw-csp-city2','tbw-pm-works-city','tbw-works-city-name'].forEach(function(id){


      var e = document.getElementById(id);


      if (e) e.textContent = name;


    });


    try { localStorage.setItem('tbw_city', name); } catch(e){}


    /* Rebuild Home so the premium-ring section and city-localised reviews


       reflect the newly selected city (cached fetches → cheap). */


    renderHomeSections();


    if (cityGateForced) {
      cityGateForced = false;
      var cs = document.getElementById('tbw-cs');
      if (cs) cs.classList.remove('forced');
      var shell = document.getElementById('tbw-shell');
      if (shell) { shell.style.filter = ''; shell.style.pointerEvents = ''; }
      document.body.style.overflow = '';
      var title = document.getElementById('tbw-cs-title');
      if (title) title.textContent = 'Select Your City';
      var sub = document.getElementById('tbw-cs-sub');
      if (sub) { sub.style.display = 'none'; sub.textContent = ''; }
    }


    setTimeout(closeCity, 260);
    if (name === 'Chennai') setTimeout(openPinCheck, 520);


    showToast('City set to ' + name + ' 📍');


  }


  window.tbwOpenCity  = openCity;


  window.tbwCloseCity = closeCity;


  window.tbwSetCity   = setCity;





  /* ================================================================


     IN-SHELL CONTENT SHEET  (More-tab pages / vendor form / blog)


     Reuses the product-sheet slide-up panel so these open INSIDE the


     app shell instead of navigating away — which used to load the real


     page behind the shell and reset the shell to Home.


  ================================================================ */


  function openContent(title, bodyHTML, ctaHTML) {


    var psEl = document.getElementById('tbw-ps');


    var body = document.getElementById('tbw-ps-body');


    var ctas = document.getElementById('tbw-ps-ctas');


    if (!psEl || !body || !ctas) return;


    body.innerHTML =


        '<h2 class="tbw-ps-nm" style="margin:6px 0 12px">' + esc(title) + '</h2>'


      + (bodyHTML || '');


    ctas.innerHTML = ctaHTML


      || '<button class="tbw-btn-cart" style="width:100%" onclick="tbwClosePS()">Close</button>';


    psEl.classList.add('open');


    body.scrollTop = 0;


  }


  window.tbwOpenContent = openContent;





  /* Static pages — real content embedded in a hidden block in the layout


     (pulled from the live store via the Shopify API). */


  function openPage(key) {


    var src = document.querySelector('#tbw-content-src [data-key="' + key + '"]');


    if (!src) { window.location.href = '/pages/' + key; return; }   /* graceful fallback */


    openContent(src.getAttribute('data-title') || '', '<div class="tbw-doc">' + src.innerHTML + '</div>');


  }


  window.tbwOpenPage = openPage;





  /* Vendor registration — native in-shell form, submitted via WhatsApp


     (the live page used the Globo form-builder app, which can't render inside


     the shell; WhatsApp keeps the flow in-app and consistent with booking). */


  function openVendor() {


    var html =


        '<p class="tbw-doc-lead">Want to partner with The Balloonwala as a decorator or vendor? '


      + 'Share your details and our team will connect with you on WhatsApp.</p>'


      + '<div class="tbw-vf">'


      + '<label class="tbw-flb">Full Name <span class="tbw-req">*</span></label>'


      + '<input class="tbw-ps-inp" id="tbw-vf-name" placeholder="Your name"/>'


      + '<label class="tbw-flb">Phone / WhatsApp <span class="tbw-req">*</span></label>'


      + '<input class="tbw-ps-inp" id="tbw-vf-phone" type="tel" maxlength="10" placeholder="10-digit number"/>'


      + '<label class="tbw-flb">City <span class="tbw-req">*</span></label>'


      + '<input class="tbw-ps-inp" id="tbw-vf-city" placeholder="Your city"/>'


      + '<label class="tbw-flb">Experience in decoration</label>'


      + '<input class="tbw-ps-inp" id="tbw-vf-exp" placeholder="e.g. 2 years, balloon decor"/>'


      + '<label class="tbw-flb">About you / your services</label>'


      + '<textarea class="tbw-ps-ta" id="tbw-vf-msg" placeholder="Your work, team size, areas you cover…"></textarea>'


      + '</div>';


    openContent('Vendor Registration', html,


      '<button class="tbw-btn-book" onclick="tbwSubmitVendor()">' + waIconSVG() + ' Submit via WhatsApp</button>');


  }


  window.tbwOpenVendor = openVendor;





  function submitVendor() {


    var name  = (document.getElementById('tbw-vf-name')  || {}).value || '';


    var phone = (document.getElementById('tbw-vf-phone') || {}).value || '';


    var city  = (document.getElementById('tbw-vf-city')  || {}).value || '';


    var exp   = (document.getElementById('tbw-vf-exp')   || {}).value || '';


    var msg   = (document.getElementById('tbw-vf-msg')   || {}).value || '';


    if (!name.trim() || phone.replace(/\D/g, '').length < 10 || !city.trim()) {


      showToast('Please add name, 10-digit phone & city');


      return;


    }


    var wa = 'Vendor Registration — The Balloonwala\n'


      + '👤 Name: ' + name + '\n'


      + '📞 Phone: ' + phone + '\n'


      + '📍 City: ' + city + '\n'


      + (exp ? '🛠️ Experience: ' + exp + '\n' : '')


      + (msg ? '📝 About: ' + msg + '\n' : '')


      + '\nI would like to register as a vendor / partner.';


    waOpen(wa);


  }


  window.tbwSubmitVendor = submitVendor;





  /* Blogs — list pulled from the public Atom feed; each article opens in-shell. */


  var blogCache = null;


  function openBlog() {


    openContent('Blogs & Guides',


      '<div id="tbw-blog-list">'


      + '<div class="tbw-sk" style="height:78px;border-radius:12px;margin-bottom:10px"></div>'


      + '<div class="tbw-sk" style="height:78px;border-radius:12px;margin-bottom:10px"></div>'


      + '<div class="tbw-sk" style="height:78px;border-radius:12px"></div></div>');


    if (blogCache) { renderBlogList(blogCache); return; }


    fetch('/blogs/news.atom')


      .then(function (r) { return r.text(); })


      .then(function (xml) {


        var doc = new DOMParser().parseFromString(xml, 'application/xml');


        var entries = Array.prototype.slice.call(doc.getElementsByTagName('entry'));


        blogCache = entries.map(function (e) {


          function tx(tag) { var n = e.getElementsByTagName(tag)[0]; return n ? n.textContent : ''; }


          var cNodes = e.getElementsByTagName('content');


          return {


            title:   tx('title'),


            summary: tx('summary'),


            content: (cNodes && cNodes[0]) ? (cNodes[0].textContent || '') : ''


          };


        });


        renderBlogList(blogCache);


      })


      .catch(function () {


        var l = document.getElementById('tbw-blog-list');


        if (l) l.innerHTML = '<p class="tbw-doc">Couldn’t load blogs right now. '


          + '<a href="/blogs/news">Open the blog ›</a></p>';


      });


  }


  window.tbwOpenBlog = openBlog;





  function renderBlogList(list) {


    var l = document.getElementById('tbw-blog-list');


    if (!l) return;


    if (!list.length) { l.innerHTML = '<p class="tbw-doc">No articles yet.</p>'; return; }


    l.innerHTML = list.map(function (b, i) {


      var sm = b.summary ? b.summary.replace(/<[^>]+>/g, '').trim().slice(0, 120) : '';


      return '<div class="tbw-blog-card" onclick="tbwOpenArticle(' + i + ')">'


        + '<div class="tbw-blog-tt">' + esc(b.title) + '</div>'


        + (sm ? '<div class="tbw-blog-sm">' + esc(sm) + '…</div>' : '')


        + '<span class="tbw-blog-rd">Read article ›</span></div>';


    }).join('');


  }





  function openArticle(i) {


    var b = blogCache && blogCache[i];


    if (!b) return;


    var hasBody = b.content && b.content.replace(/<[^>]+>/g, '').trim().length > 20;


    var html = '<div class="tbw-doc">' + (hasBody ? b.content : '<p>' + esc(b.summary) + '</p>') + '</div>';


    openContent(b.title, html,


      '<div class="tbw-cta-2col">'


      + '<button class="tbw-btn-cart" onclick="tbwOpenBlog()">‹ All articles</button>'


      + '<button class="tbw-btn-wa-s" onclick="tbwClosePS()">Close</button>'


      + '</div>');


  }


  window.tbwOpenArticle = openArticle;





  /* ================================================================


     SWIPE TO DISMISS


  ================================================================ */


  /* Generalized swipe-to-dismiss — used for both #tbw-ps and #tbw-guide.
     closeFn  = the close function to call when swipe-down threshold is met. */
  function attachSwipeDismiss(panelId, handleId, scrollId, closeFn) {
    var panel  = document.getElementById(panelId);
    var handle = document.getElementById(handleId);
    var scroll = document.getElementById(scrollId);
    if (!panel || !handle || !scroll) return;
    var startY = 0, currY = 0, dragging = false, atTop = false;
    function onStart(y, fromHandle) {
      dragging = true; startY = y; currY = y;
      atTop = fromHandle || scroll.scrollTop <= 0;
      panel.style.transition = 'none';
    }
    function onMove(y) {
      if (!dragging) return; currY = y;
      var dy = currY - startY;
      if (dy > 0 && atTop) panel.style.transform = 'translateX(-50%) translateY(' + dy + 'px)';
    }
    function onEnd() {
      if (!dragging) return; dragging = false;
      panel.style.transition = 'transform .3s cubic-bezier(.32,1,.32,1)';
      if (currY - startY > 90 && atTop) closeFn();
      panel.style.transform = '';
    }
    handle.addEventListener('touchstart', function(e){ onStart(e.touches[0].clientY, true); }, {passive:true});
    handle.addEventListener('touchmove', function(e){
      if (dragging && (e.touches[0].clientY - startY) > 0 && e.cancelable) e.preventDefault();
      onMove(e.touches[0].clientY);
    }, {passive:false});
    handle.addEventListener('touchend',   onEnd);
    handle.addEventListener('touchcancel', onEnd);
    handle.addEventListener('mousedown', function(e){
      onStart(e.clientY, true);
      var mm = function(ev){ onMove(ev.clientY); };
      var mu = function(){ onEnd(); document.removeEventListener('mousemove',mm); document.removeEventListener('mouseup',mu); };
      document.addEventListener('mousemove', mm);
      document.addEventListener('mouseup', mu);
    });
    scroll.addEventListener('touchstart', function(e){ onStart(e.touches[0].clientY, false); }, {passive:true});
    scroll.addEventListener('touchmove', function(e){
      if (scroll.scrollTop <= 0 && currY - startY > 0) e.preventDefault();
      onMove(e.touches[0].clientY);
    }, {passive:false});
    scroll.addEventListener('touchend',   onEnd);
    scroll.addEventListener('touchcancel', onEnd);
  }

  /* Attach swipe-to-dismiss for the product sheet */
  attachSwipeDismiss('tbw-ps-pan', 'tbw-ps-handle', 'tbw-ps-body', closePS);
  /* Note: guide swipe dismiss is attached each time openGuide() renders it,
     since guide.innerHTML is replaced on every open. */





  /* ================================================================


     SHARE


  ================================================================ */


  function tbwShareProduct(handle, title) {


    var url = window.location.origin + '/products/' + handle;


    if (navigator.share) {


      navigator.share({ title: title, url: url }).catch(function(){});


    } else {


      navigator.clipboard.writeText(url).then(function(){


        showToast('Link copied!');


      }).catch(function(){


        showToast('Link: ' + url);


      });


    }


  }


  window.tbwShareProduct = tbwShareProduct;





  /* ================================================================


     INIT


  ================================================================ */


  function tbwDismissOffer() {
    try { localStorage.setItem('tbw_offer_dismissed', '1'); } catch(e){}
    var bar = document.getElementById('tbw-offer-bar');
    if (bar) { bar.style.maxHeight = '0'; bar.style.opacity = '0'; setTimeout(function(){ bar.style.display = 'none'; }, 350); }
  }
  window.tbwDismissOffer = tbwDismissOffer;


  function init() {


    /* Desktop: shell is hidden via CSS — skip all JS initialisation */


    if (window.innerWidth >= 750) return;





    /* Sync the cart tab with Shopify's real cart (survives reloads / checkout back) */


    hydrateCart().then(checkBookingReturn);





    /* Restore city — URL slug wins (SERP landing), then localStorage, then default */


    (function () {


      var path = window.location.pathname.toLowerCase();


      var cityMap = [


        [/bangalore|bengaluru/, 'Bangalore'],


        [/hyderabad/,           'Hyderabad'],


        [/pune/,                'Pune'],


        [/mumbai/,              'Mumbai'],


        [/surat/,               'Surat'],


        [/delhi/,               'Delhi'],


        [/ahmedabad/,           'Ahmedabad'],


        [/kolkata|calcutta/,    'Kolkata'],


        [/chennai/,             'Chennai'],


        [/gurgaon|gurugram/,    'Gurgaon'],


        [/jaipur/,              'Jaipur'],


        [/chandigarh/,          'Chandigarh'],


        [/indore/,              'Indore'],


        [/lucknow/,             'Lucknow'],


        [/kanpur/,              'Kanpur'],


        [/raipur/,              'Raipur']


      ];


      var urlCity = null;


      for (var i = 0; i < cityMap.length; i++) {


        if (cityMap[i][0].test(path)) { urlCity = cityMap[i][1]; break; }


      }


      var cityName = urlCity;


      if (!cityName) {


        try { cityName = localStorage.getItem('tbw_city') || null; } catch(e){}


      }


      if (cityName) {


        currentCity = cityName;
        tbwBqNavSync();


        ['tbw-sel-city','tbw-hero-city','tbw-pm-city','tbw-csp-city','tbw-csp-city2','tbw-pm-works-city','tbw-works-city-name'].forEach(function(id){


          var e = document.getElementById(id); if (e) e.textContent = cityName;


        });


        document.querySelectorAll('.tbw-cs-opt').forEach(function(el){


          var nm = el.querySelector('.tbw-cs-nm');


          if (nm) el.classList.toggle('on', nm.textContent === cityName);


        });


        if (urlCity) { try { localStorage.setItem('tbw_city', urlCity); } catch(e){} }


      }


    })();





    /* Time-based greeting */


    var g = document.getElementById('tbw-greeting');


    if (g) {


      var h = new Date().getHours();


      var greet = h < 12 ? 'Good morning' : (h < 17 ? 'Good afternoon' : 'Good evening');


      g.textContent = greet + ' 🎈';


    }





    /* First order offer banner */
    var offerDismissed = false;
    try { offerDismissed = !!localStorage.getItem('tbw_offer_dismissed'); } catch(e){}
    var offerBar = document.getElementById('tbw-offer-bar');
    if (offerBar) {
      if (offerDismissed) {
        offerBar.style.display = 'none';
      }
    }



    /* Build the lengthy home page (category sections + reviews) */


    renderHomeSections();





    /* Gentle bounce on the city chip so users notice & can switch city */


    var cityChip = document.querySelector('.tbw-city-p');


    if (cityChip) {


      setTimeout(function () {


        cityChip.classList.add('tbw-city-bounce');


        setTimeout(function () { cityChip.classList.remove('tbw-city-bounce'); }, 1600);


      }, 600);


    }





    /* Mandatory city gate — no saved city yet means this is a first-time
       visitor. The old bubble hint wasn't catching enough eyes and users kept
       browsing without picking a city, so leads were going to the wrong
       team/inventory. The gate now blocks the app until a city is chosen;
       returning visitors (saved city already in localStorage) skip straight
       through with no interruption. The bubble is superseded by the gate. */


    var hasSavedCity = false;


    try { hasSavedCity = !!localStorage.getItem('tbw_city'); } catch(e){}


    var cb = document.getElementById('tbw-city-bubble');
    if (cb) cb.style.display = 'none';


    if (!hasSavedCity) {
      forceOpenCity();
    }





    /* Search bubble — show once, dismiss on focus */


    setTimeout(function(){


      var srchBubble = document.getElementById('tbw-srch-bubble');


      if (!srchBubble) return;


      /* auto-dismiss after 4 s */


      var srchTimer = setTimeout(function(){ tbwDismissBubble('tbw-srch-bubble'); }, 4000);


      /* dismiss on input focus */


      var srchInp = document.getElementById('tbw-srch-inp');


      if (srchInp) srchInp.addEventListener('focus', function(){


        clearTimeout(srchTimer);


        tbwDismissBubble('tbw-srch-bubble');


      }, { once: true });


    }, 1200);





    window.dataLayer = window.dataLayer || [];





    /* Tapping the home search bar jumps straight to Explore and focuses its


       search input — keyboard stays up, user starts typing immediately. */


    var homeInp = document.getElementById('tbw-srch-inp');


    if (homeInp) {


      homeInp.addEventListener('focus', function () {


        var q = homeInp.value.trim();


        homeInp.blur();


        goTab('explore');


        setTimeout(function () {


          var expSrch = document.getElementById('tbw-exp-srch');


          if (!expSrch) return;


          if (q) { expSrch.value = q; onExpSearch(q); }


          expSrch.focus();


        }, 120);


      });


    }





    /* ── BACK BUTTON / SWIPE-BACK HANDLING ──


       Sheet close uses hashchange (hash = #tbw-sheet while sheet is open) because


       hashchange fires reliably on both Android back button and iOS edge-swipe,


       while popstate with state-only pushState is unreliable on iOS.


       Tab navigation still uses popstate + a guard state. */


    history.pushState({ tbwApp: true }, '');


    window.addEventListener('popstate', function () {
      /* If product sheet is open, let hashchange handle the close — do nothing here */
      var ps = document.getElementById('tbw-ps');
      if (ps && (ps.classList.contains('open') || ps.classList.contains('tbw-closing'))) return;


      /* Sheet is handled by hashchange; only guard tab navigation here */


      var homeScr = document.getElementById('tbw-s-home');


      if (homeScr && !homeScr.classList.contains('on')) {


        goTab('home');


        history.pushState({ tbwApp: true }, '');


      }


    });


    



  /* ================================================================
     OUR RECENT WORKS GALLERY — 137 images, smart rotation
     Visit 1 → batch 0 (imgs 1-46)
     Visit 2 → batch 1 (imgs 47-92)
     Visit 3 → batch 2 (imgs 93-137)
     Visit 4+ → seeded shuffle of all 137, pick 46
     Counter resets each calendar day.
  ================================================================ */

  var WORKS_B0 = [
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review1.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review2.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review3.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review4.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review5.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review6.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review7.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review8.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review9.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review10.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review11.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review12.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review13.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review14.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review15.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review16.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review17.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review18.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review19.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review20.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review21.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review22.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review23.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review24.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review25.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review26.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review27.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review28.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review29.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review30.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review31.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review32.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review33.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review34.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review35.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review36.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review37.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review38.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review39.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review40.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review41.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review42.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review43.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review44.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review45.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review46.jpg'
  ];
  var WORKS_B1 = [
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review47.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review48.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review49.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review50.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review51.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review52.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review53.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review54.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review55.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review56.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review57.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review58.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review59.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review60.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review61.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review62.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review63.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review64.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review65.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review66.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review67.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review68.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review69.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review70.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review71.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review72.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review73.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review74.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review75.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review76.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review77.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review78.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review79.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review80.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review81.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review82.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review83.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review84.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review85.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review86.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review87.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review88.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review89.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review90.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review91.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review92.jpg'
  ];
  var WORKS_B2 = [
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review93.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review94.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review95.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review96.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review97.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review98.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review99.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review100.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review101.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review102.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review103.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review104.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review105.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review106.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review107.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review108.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review109.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review110.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review111.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review112.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review113.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review114.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review115.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review116.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review117.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review118.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review119.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review120.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review121.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review122.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review123.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review124.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review125.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review126.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review127.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review128.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review129.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review130.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review131.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review132.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review133.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review134.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review135.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review136.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review137.jpg'
  ];
  var WORKS_ALL = [
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review1.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review2.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review3.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review4.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review5.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review6.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review7.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review8.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review9.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review10.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review11.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review12.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review13.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review14.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review15.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review16.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review17.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review18.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review19.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review20.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review21.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review22.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review23.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review24.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review25.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review26.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review27.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review28.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review29.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review30.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review31.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review32.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review33.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review34.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review35.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review36.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review37.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review38.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review39.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review40.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review41.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review42.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review43.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review44.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review45.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review46.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review47.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review48.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review49.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review50.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review51.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review52.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review53.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review54.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review55.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review56.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review57.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review58.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review59.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review60.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review61.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review62.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review63.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review64.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review65.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review66.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review67.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review68.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review69.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review70.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review71.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review72.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review73.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review74.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review75.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review76.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review77.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review78.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review79.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review80.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review81.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review82.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review83.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review84.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review85.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review86.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review87.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review88.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review89.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review90.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review91.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review92.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review93.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review94.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review95.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review96.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review97.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review98.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review99.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review100.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review101.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review102.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review103.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review104.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review105.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review106.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review107.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review108.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review109.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review110.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review111.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review112.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review113.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review114.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review115.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review116.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review117.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review118.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review119.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review120.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review121.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review122.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review123.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review124.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review125.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review126.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review127.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review128.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review129.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review130.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review131.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review132.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review133.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review134.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review135.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review136.jpg',
    'https://cdn.shopify.com/s/files/1/0823/6502/2520/files/Review137.jpg'
  ];

  function worksSeededShuffle(arr, seed) {
    /* Deterministic Fisher-Yates with a simple LCG so same seed = same order */
    var s = seed % 2147483647;
    if (s <= 0) s += 2147483646;
    function rand() { s = s * 16807 % 2147483647; return (s - 1) / 2147483646; }
    var a = arr.slice();
    for (var i = a.length - 1; i > 0; i--) {
      var j = Math.floor(rand() * (i + 1));
      var t = a[i]; a[i] = a[j]; a[j] = t;
    }
    return a;
  }

  function getWorksBatch() {
    var today = new Date().toISOString().slice(0, 10); /* YYYY-MM-DD */
    var stored;
    try { stored = JSON.parse(localStorage.getItem('tbw_works_state') || 'null'); } catch(e) { stored = null; }
    if (!stored || stored.day !== today) {
      stored = { day: today, visit: 0 };
    }
    var visit = stored.visit;
    /* Increment and save for next open */
    stored.visit = visit + 1;
    try { localStorage.setItem('tbw_works_state', JSON.stringify(stored)); } catch(e) {}

    if (visit === 0) return WORKS_B0;
    if (visit === 1) return WORKS_B1;
    if (visit === 2) return WORKS_B2;
    /* Visit 3+ : seeded shuffle using visit number + day hash so it varies */
    var daySeed = today.replace(/-/g, '') | 0;
    var seed = daySeed + visit * 997;
    return worksSeededShuffle(WORKS_ALL, seed).slice(0, 46);
  }

  function openWorks() {
    var sheet = document.getElementById('tbw-works');
    var body  = document.getElementById('tbw-works-body');
    var ov    = document.getElementById('tbw-works-ov');
    if (!sheet || !body) return;

    var batch = getWorksBatch();
    body.innerHTML = '<div class="tbw-works-grid">'
      + batch.map(function(src, i) {
          return '<div class="tbw-works-thumb" onclick="tbwOpenWorksLb(\'' + src + '\')">'
            + '<img src="' + src + '?width=400&format=webp" loading="lazy" alt="Recent work"/>'
            + '</div>';
        }).join('')
      + '</div>';

    if (ov) {
      var ov2 = ov.cloneNode(false);
      ov.parentNode.replaceChild(ov2, ov);
      ov2.addEventListener('click', function() { closeWorks(); });
    }
    sheet.classList.add('open');
    body.scrollTop = 0;
    if (window.location.hash !== '#tbw-works-open') { window.location.hash = 'tbw-works-open'; }
  }
  window.tbwOpenWorks = openWorks;


  function closeWorks() {
    var sheet = document.getElementById('tbw-works');
    var pan   = document.getElementById('tbw-works-pan');
    if (!sheet) return;
    if (pan) { pan.style.transform = ''; pan.style.transition = ''; }
    sheet.classList.remove('open');
    sheet.classList.add('tbw-closing');
    setTimeout(function() { sheet.classList.remove('tbw-closing'); }, 420);
    if (window.location.hash === '#tbw-works-open') { _worksHashBack = true; history.back(); }
  }
  window.tbwCloseWorks = closeWorks;

  function openWorksLb(src) {
    var lb  = document.getElementById('tbw-works-lb');
    var img = document.getElementById('tbw-works-lb-img');
    if (!lb || !img) return;
    img.src = src;
    lb.classList.add('open');
  }
  window.tbwOpenWorksLb = openWorksLb;

  function closeWorksLb() {
    var lb = document.getElementById('tbw-works-lb');
    if (lb) lb.classList.remove('open');
  }
  window.tbwCloseWorksLb = closeWorksLb;

  window.addEventListener('hashchange', function () {


      /* Ignore guard: hashchange fired by our own history.back() inside closeGuide */
      if (_guideHashBack) { _guideHashBack = false; return; }


      /* Guide sheet open + hash left #tbw-guide-open → close only the guide sheet */
      var guide = document.getElementById('tbw-guide');
      if (guide && guide.classList.contains('open') && window.location.hash !== '#tbw-guide-open') {
        /* Call full closeGuide so animation + inline-style cleanup both run.
           Set _guideHashBack first: closeGuide() would otherwise call history.back()
           again, creating a loop. */
        _guideHashBack = true;
        closeGuide();
        return;
      }


      /* Ignore the hashchange we fire ourselves when calling history.back() from closePS() */


      if (_worksHashBack) { _worksHashBack = false; return; }
      var works = document.getElementById('tbw-works');
      if (works && works.classList.contains('open') && window.location.hash !== '#tbw-works-open') {
        _worksHashBack = true; closeWorks(); return;
      }
      if (window.location.hash === '#tbw-works-open') return;

      if (_sheetHashBack) { _sheetHashBack = false; return; }


      /* Ignore hash TO #tbw-guide-open: openGuide pushes this while PS is still open,
         and without this guard the handler would call closePS() immediately. */
      if (window.location.hash === '#tbw-guide-open') return;


      /* Hash navigated away from #tbw-sheet → user pressed back while sheet was open */


      if (window.location.hash !== '#tbw-sheet') {


        var ps = document.getElementById('tbw-ps');


        if (ps && ps.classList.contains('open')) { closePS(); }


      }


    });





    /* ── OVERLAY CLOSE ──


       Attach touchend directly on the overlay so it fires immediately on


       mobile without waiting for the browser's click synthesis. Also handles


       desktop clicks. e.preventDefault() on touchend suppresses the ghost


       click so the inline onclick on the element doesn't double-fire. */


    var ov = document.getElementById('tbw-ps-ov');


    if (ov) {


      ov.addEventListener('touchend', function (e) {


        e.preventDefault();


        closePS();


      });


      ov.addEventListener('click', function () {


        closePS();


      });


    }





    /* ── PRODUCT DEEP LINK ──


       When a user lands directly on /products/{handle} (e.g. from Google SERP


       or a shared link), the shell shows home tab but the product sheet never


       opens. Fix: after all listeners are attached, read the handle from the URL


       pathname, fetch it, and open the sheet. 500ms delay lets the shell CSS


       transitions initialise so the slide-up animation actually runs. */


    setTimeout(function () {


      var m = window.location.pathname.match(/^\/products\/([^\/\?#]+)/i);


      if (!m) return;


      findProductByHandle(m[1]).then(function (p) {


        if (p) openSheet(p.id);


      });


    }, 500);





  }





  if (document.readyState === 'loading') {


    document.addEventListener('DOMContentLoaded', init);


  } else {


    init();


  }





})();









































